(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var sheet = require('@emotion/sheet');
var stylis = require('stylis');
require('@emotion/weak-memoize');
require('@emotion/memoize');

var last = function last(arr) {
  return arr.length ? arr[arr.length - 1] : null;
};

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (stylis.token(character)) {
      case 0:
        // &\f
        if (character === 38 && stylis.peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += stylis.identifier(stylis.position - 1);
        break;

      case 2:
        parsed[index] += stylis.delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = stylis.peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += stylis.from(character);
    }
  } while (character = stylis.next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return stylis.dealloc(toRules(stylis.alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // .length indicates if this rule contains pseudo or not
  !element.length) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};
var ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';

var isIgnoringComment = function isIgnoringComment(element) {
  return !!element && element.type === 'comm' && element.children.indexOf(ignoreFlag) > -1;
};

var createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
  return function (element, index, children) {
    if (element.type !== 'rule') return;
    var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);

    if (unsafePseudoClasses && cache.compat !== true) {
      var prevElement = index > 0 ? children[index - 1] : null;

      if (prevElement && isIgnoringComment(last(prevElement.children))) {
        return;
      }

      unsafePseudoClasses.forEach(function (unsafePseudoClass) {
        console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
      });
    }
  };
};

var isImportRule = function isImportRule(element) {
  return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};

var isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
  for (var i = index - 1; i >= 0; i--) {
    if (!isImportRule(children[i])) {
      return true;
    }
  }

  return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user


var nullifyElement = function nullifyElement(element) {
  element.type = '';
  element.value = '';
  element["return"] = '';
  element.children = '';
  element.props = '';
};

var incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
  if (!isImportRule(element)) {
    return;
  }

  if (element.parent) {
    console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
    nullifyElement(element);
  } else if (isPrependedWithRegularRules(index, children)) {
    console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
    nullifyElement(element);
  }
};

var defaultStylisPlugins = [stylis.prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if ("production" !== 'production' && !key) {
    throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\n" + "If multiple caches share the same key they might \"fight\" for each other's style elements.");
  }

  if ( key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  if ("production" !== 'production') {
    // $FlowFixMe
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if ("production" !== 'production') {
    omnipresentPlugins.push(createUnsafeSelectorsAlarm({
      get compat() {
        return cache.compat;
      }

    }), incorrectImportAlarm);
  }

  {
    var currentSheet;
    var finalizingPlugins = [stylis.stringify, "production" !== 'production' ? function (element) {
      if (!element.root) {
        if (element["return"]) {
          currentSheet.insert(element["return"]);
        } else if (element.value && element.type !== stylis.COMMENT) {
          // insert empty rule in non-production environments
          // so @emotion/jest can grab `key` from the (JS)DOM for caches without any rules inserted yet
          currentSheet.insert(element.value + "{}");
        }
      }
    } : stylis.rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = stylis.middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis$1 = function stylis$1(styles) {
      return stylis.serialize(stylis.compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      if ("production" !== 'production' && serialized.map !== undefined) {
        currentSheet = {
          insert: function insert(rule) {
            sheet.insert(rule + serialized.map);
          }
        };
      }

      stylis$1(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new sheet.StyleSheet({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

exports.default = createCache;

},{"@emotion/memoize":8,"@emotion/sheet":10,"@emotion/weak-memoize":13,"stylis":15}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var createCache = require('@emotion/cache');
var serialize = require('@emotion/serialize');
var utils = require('@emotion/utils');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var createCache__default = /*#__PURE__*/_interopDefault(createCache);

function insertWithoutScoping(cache, serialized) {
  if (cache.inserted[serialized.name] === undefined) {
    return cache.insert('', serialized, cache.sheet, true);
  }
}

function merge(registered, css, className) {
  var registeredStyles = [];
  var rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);

  if (registeredStyles.length < 2) {
    return className;
  }

  return rawClassName + css(registeredStyles);
}

var createEmotion = function createEmotion(options) {
  var cache = createCache__default['default'](options); // $FlowFixMe

  cache.sheet.speedy = function (value) {
    if ("production" !== 'production' && this.ctr !== 0) {
      throw new Error('speedy must be changed before any rules are inserted');
    }

    this.isSpeedy = value;
  };

  cache.compat = true;

  var css = function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var serialized = serialize.serializeStyles(args, cache.registered, undefined);
    utils.insertStyles(cache, serialized, false);
    return cache.key + "-" + serialized.name;
  };

  var keyframes = function keyframes() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var serialized = serialize.serializeStyles(args, cache.registered);
    var animation = "animation-" + serialized.name;
    insertWithoutScoping(cache, {
      name: serialized.name,
      styles: "@keyframes " + animation + "{" + serialized.styles + "}"
    });
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    var serialized = serialize.serializeStyles(args, cache.registered);
    insertWithoutScoping(cache, serialized);
  };

  var cx = function cx() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return merge(cache.registered, css, classnames(args));
  };

  return {
    css: css,
    cx: cx,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    hydrate: function hydrate(ids) {
      ids.forEach(function (key) {
        cache.inserted[key] = true;
      });
    },
    flush: function flush() {
      cache.registered = {};
      cache.inserted = {};
      cache.sheet.flush();
    },
    // $FlowFixMe
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: utils.getRegisteredStyles.bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
};

var classnames = function classnames(args) {
  var cls = '';

  for (var i = 0; i < args.length; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};

exports.default = createEmotion;

},{"@emotion/cache":1,"@emotion/serialize":9,"@emotion/utils":12}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var createCache = require("@emotion/cache"), serialize = require("@emotion/serialize"), utils = require("@emotion/utils");

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}

var createCache__default = _interopDefault(createCache);

function insertWithoutScoping(cache, serialized) {
  if (void 0 === cache.inserted[serialized.name]) return cache.insert("", serialized, cache.sheet, !0);
}

function merge(registered, css, className) {
  var registeredStyles = [], rawClassName = utils.getRegisteredStyles(registered, registeredStyles, className);
  return registeredStyles.length < 2 ? className : rawClassName + css(registeredStyles);
}

var createEmotion = function(options) {
  var cache = createCache__default.default(options);
  cache.sheet.speedy = function(value) {
    this.isSpeedy = value;
  }, cache.compat = !0;
  var css = function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
    var serialized = serialize.serializeStyles(args, cache.registered, void 0);
    return utils.insertStyles(cache, serialized, !1), cache.key + "-" + serialized.name;
  };
  return {
    css: css,
    cx: function() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) args[_key4] = arguments[_key4];
      return merge(cache.registered, css, classnames(args));
    },
    injectGlobal: function() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) args[_key3] = arguments[_key3];
      var serialized = serialize.serializeStyles(args, cache.registered);
      insertWithoutScoping(cache, serialized);
    },
    keyframes: function() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) args[_key2] = arguments[_key2];
      var serialized = serialize.serializeStyles(args, cache.registered), animation = "animation-" + serialized.name;
      return insertWithoutScoping(cache, {
        name: serialized.name,
        styles: "@keyframes " + animation + "{" + serialized.styles + "}"
      }), animation;
    },
    hydrate: function(ids) {
      ids.forEach((function(key) {
        cache.inserted[key] = !0;
      }));
    },
    flush: function() {
      cache.registered = {}, cache.inserted = {}, cache.sheet.flush();
    },
    sheet: cache.sheet,
    cache: cache,
    getRegisteredStyles: utils.getRegisteredStyles.bind(null, cache.registered),
    merge: merge.bind(null, cache.registered, css)
  };
}, classnames = function classnames(args) {
  for (var cls = "", i = 0; i < args.length; i++) {
    var arg = args[i];
    if (null != arg) {
      var toAdd = void 0;
      switch (typeof arg) {
       case "boolean":
        break;

       case "object":
        if (Array.isArray(arg)) toAdd = classnames(arg); else for (var k in toAdd = "", 
        arg) arg[k] && k && (toAdd && (toAdd += " "), toAdd += k);
        break;

       default:
        toAdd = arg;
      }
      toAdd && (cls && (cls += " "), cls += toAdd);
    }
  }
  return cls;
};

exports.default = createEmotion;

},{"@emotion/cache":1,"@emotion/serialize":9,"@emotion/utils":12}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('@emotion/cache');
require('@emotion/serialize');
require('@emotion/utils');
var createInstance_dist_emotionCssCreateInstance = require('../create-instance/dist/emotion-css-create-instance.cjs.dev.js');

var _createEmotion = createInstance_dist_emotionCssCreateInstance['default']({
  key: 'css'
}),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    cache = _createEmotion.cache;

exports.cache = cache;
exports.css = css;
exports.cx = cx;
exports.flush = flush;
exports.getRegisteredStyles = getRegisteredStyles;
exports.hydrate = hydrate;
exports.injectGlobal = injectGlobal;
exports.keyframes = keyframes;
exports.merge = merge;
exports.sheet = sheet;

},{"../create-instance/dist/emotion-css-create-instance.cjs.dev.js":2,"@emotion/cache":1,"@emotion/serialize":9,"@emotion/utils":12}],5:[function(require,module,exports){
'use strict';

if ("production" === "production") {
  module.exports = require("./emotion-css.cjs.prod.js");
} else {
  module.exports = require("./emotion-css.cjs.dev.js");
}

},{"./emotion-css.cjs.dev.js":4,"./emotion-css.cjs.prod.js":6}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), require("@emotion/cache"), require("@emotion/serialize"), require("@emotion/utils");

var createInstance_dist_emotionCssCreateInstance = require("../create-instance/dist/emotion-css-create-instance.cjs.prod.js"), _createEmotion = createInstance_dist_emotionCssCreateInstance.default({
  key: "css"
}), flush = _createEmotion.flush, hydrate = _createEmotion.hydrate, cx = _createEmotion.cx, merge = _createEmotion.merge, getRegisteredStyles = _createEmotion.getRegisteredStyles, injectGlobal = _createEmotion.injectGlobal, keyframes = _createEmotion.keyframes, css = _createEmotion.css, sheet = _createEmotion.sheet, cache = _createEmotion.cache;

exports.cache = cache, exports.css = css, exports.cx = cx, exports.flush = flush, 
exports.getRegisteredStyles = getRegisteredStyles, exports.hydrate = hydrate, exports.injectGlobal = injectGlobal, 
exports.keyframes = keyframes, exports.merge = merge, exports.sheet = sheet;

},{"../create-instance/dist/emotion-css-create-instance.cjs.prod.js":3,"@emotion/cache":1,"@emotion/serialize":9,"@emotion/utils":12}],7:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

exports.default = murmur2;

},{}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

exports.default = memoize;

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var hashString = require('@emotion/hash');
var unitless = require('@emotion/unitless');
var memoize = require('@emotion/memoize');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var hashString__default = /*#__PURE__*/_interopDefault(hashString);
var unitless__default = /*#__PURE__*/_interopDefault(unitless);
var memoize__default = /*#__PURE__*/_interopDefault(memoize);

var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize__default['default'](function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless__default['default'][key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

if ("production" !== 'production') {
  var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
  var contentValues = ['normal', 'none', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;
  var msPattern = /^-ms-/;
  var hyphenPattern = /-(.)/g;
  var hyphenatedCache = {};

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    var processed = oldProcessStyleValue(key, value);

    if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
      hyphenatedCache[key] = true;
      console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
        return _char.toUpperCase();
      }) + "?");
    }

    return processed;
  };
}

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {
    if ("production" !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
      throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
    }

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          if ("production" !== 'production' && interpolation.map !== undefined) {
            styles += interpolation.map;
          }

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        } else if ("production" !== 'production') {
          console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        break;
      }

    case 'string':
      if ("production" !== 'production') {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
          return "${" + fakeVarName + "}";
        });

        if (matched.length) {
          console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
        }
      }

      break;
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
          throw new Error('Component selectors can only be used in conjunction with @emotion/babel-plugin.');
        }

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {
                if ("production" !== 'production' && _key === 'undefined') {
                  console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                }

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var sourceMapPattern;

if ("production" !== 'production') {
  sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;
} // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {
    if ("production" !== 'production' && strings[0] === undefined) {
      console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
    }

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {
      if ("production" !== 'production' && strings[i] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[i];
    }
  }

  var sourceMap;

  if ("production" !== 'production') {
    styles = styles.replace(sourceMapPattern, function (match) {
      sourceMap = match;
      return '';
    });
  } // using a global regex with .exec is stateful so lastIndex has to be reset each time


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = hashString__default['default'](styles) + identifierName;

  if ("production" !== 'production') {
    // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
    return {
      name: name,
      styles: styles,
      map: sourceMap,
      next: cursor,
      toString: function toString() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    };
  }

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

exports.serializeStyles = serializeStyles;

},{"@emotion/hash":7,"@emotion/memoize":8,"@emotion/unitless":11}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        before = _this.prepend ? _this.container.firstChild : _this.before;
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if ("production" !== 'production') {
      var isImportRule = rule.charCodeAt(0) === 64 && rule.charCodeAt(1) === 105;

      if (isImportRule && this._alreadyInsertedOrderInsensitiveRule) {
        // this would only cause problem in speedy mode
        // but we don't want enabling speedy to affect the observable behavior
        // so we report this error at all times
        console.error("You're attempting to insert the following rule:\n" + rule + '\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules.');
      }
      this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !isImportRule;
    }

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if ("production" !== 'production' && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(rule)) {
          console.error("There was a problem inserting the following rule: \"" + rule + "\"", e);
        }
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;

    if ("production" !== 'production') {
      this._alreadyInsertedOrderInsensitiveRule = false;
    }
  };

  return StyleSheet;
}();

exports.StyleSheet = StyleSheet;

},{}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

exports.default = unitlessKeys;

},{}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isBrowser = "object" !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === false ) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      current = current.next;
    } while (current !== undefined);
  }
};

exports.getRegisteredStyles = getRegisteredStyles;
exports.insertStyles = insertStyles;

},{}],13:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

exports.default = weakMemoize;

},{}],14:[function(require,module,exports){
/**
 * Copyright 2016 Google Inc. All Rights Reserved.
 *
 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.
 *
 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 */
(function() {
'use strict';

// Exit early if we're not running in a browser.
if (typeof window !== 'object') {
  return;
}

// Exit early if all IntersectionObserver and IntersectionObserverEntry
// features are natively supported.
if ('IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {

  // Minimal polyfill for Edge 15's lack of `isIntersecting`
  // See: https://github.com/w3c/IntersectionObserver/issues/211
  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {
    Object.defineProperty(window.IntersectionObserverEntry.prototype,
      'isIntersecting', {
      get: function () {
        return this.intersectionRatio > 0;
      }
    });
  }
  return;
}


/**
 * A local reference to the document.
 */
var document = window.document;


/**
 * An IntersectionObserver registry. This registry exists to hold a strong
 * reference to IntersectionObserver instances currently observing a target
 * element. Without this registry, instances without another reference may be
 * garbage collected.
 */
var registry = [];


/**
 * Creates the global IntersectionObserverEntry constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry
 * @param {Object} entry A dictionary of instance properties.
 * @constructor
 */
function IntersectionObserverEntry(entry) {
  this.time = entry.time;
  this.target = entry.target;
  this.rootBounds = entry.rootBounds;
  this.boundingClientRect = entry.boundingClientRect;
  this.intersectionRect = entry.intersectionRect || getEmptyRect();
  this.isIntersecting = !!entry.intersectionRect;

  // Calculates the intersection ratio.
  var targetRect = this.boundingClientRect;
  var targetArea = targetRect.width * targetRect.height;
  var intersectionRect = this.intersectionRect;
  var intersectionArea = intersectionRect.width * intersectionRect.height;

  // Sets intersection ratio.
  if (targetArea) {
    // Round the intersection ratio to avoid floating point math issues:
    // https://github.com/w3c/IntersectionObserver/issues/324
    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));
  } else {
    // If area is zero and is intersecting, sets to 1, otherwise to 0
    this.intersectionRatio = this.isIntersecting ? 1 : 0;
  }
}


/**
 * Creates the global IntersectionObserver constructor.
 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface
 * @param {Function} callback The function to be invoked after intersection
 *     changes have queued. The function is not invoked if the queue has
 *     been emptied by calling the `takeRecords` method.
 * @param {Object=} opt_options Optional configuration options.
 * @constructor
 */
function IntersectionObserver(callback, opt_options) {

  var options = opt_options || {};

  if (typeof callback != 'function') {
    throw new Error('callback must be a function');
  }

  if (options.root && options.root.nodeType != 1) {
    throw new Error('root must be an Element');
  }

  // Binds and throttles `this._checkForIntersections`.
  this._checkForIntersections = throttle(
      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);

  // Private properties.
  this._callback = callback;
  this._observationTargets = [];
  this._queuedEntries = [];
  this._rootMarginValues = this._parseRootMargin(options.rootMargin);

  // Public properties.
  this.thresholds = this._initThresholds(options.threshold);
  this.root = options.root || null;
  this.rootMargin = this._rootMarginValues.map(function(margin) {
    return margin.value + margin.unit;
  }).join(' ');
}


/**
 * The minimum interval within which the document will be checked for
 * intersection changes.
 */
IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;


/**
 * The frequency in which the polyfill polls for intersection changes.
 * this can be updated on a per instance basis and must be set prior to
 * calling `observe` on the first target.
 */
IntersectionObserver.prototype.POLL_INTERVAL = null;

/**
 * Use a mutation observer on the root element
 * to detect intersection changes.
 */
IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;


/**
 * Starts observing a target element for intersection changes based on
 * the thresholds values.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.observe = function(target) {
  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {
    return item.element == target;
  });

  if (isTargetAlreadyObserved) {
    return;
  }

  if (!(target && target.nodeType == 1)) {
    throw new Error('target must be an Element');
  }

  this._registerInstance();
  this._observationTargets.push({element: target, entry: null});
  this._monitorIntersections();
  this._checkForIntersections();
};


/**
 * Stops observing a target element for intersection changes.
 * @param {Element} target The DOM element to observe.
 */
IntersectionObserver.prototype.unobserve = function(target) {
  this._observationTargets =
      this._observationTargets.filter(function(item) {

    return item.element != target;
  });
  if (!this._observationTargets.length) {
    this._unmonitorIntersections();
    this._unregisterInstance();
  }
};


/**
 * Stops observing all target elements for intersection changes.
 */
IntersectionObserver.prototype.disconnect = function() {
  this._observationTargets = [];
  this._unmonitorIntersections();
  this._unregisterInstance();
};


/**
 * Returns any queue entries that have not yet been reported to the
 * callback and clears the queue. This can be used in conjunction with the
 * callback to obtain the absolute most up-to-date intersection information.
 * @return {Array} The currently queued entries.
 */
IntersectionObserver.prototype.takeRecords = function() {
  var records = this._queuedEntries.slice();
  this._queuedEntries = [];
  return records;
};


/**
 * Accepts the threshold value from the user configuration object and
 * returns a sorted array of unique threshold values. If a value is not
 * between 0 and 1 and error is thrown.
 * @private
 * @param {Array|number=} opt_threshold An optional threshold value or
 *     a list of threshold values, defaulting to [0].
 * @return {Array} A sorted list of unique and valid threshold values.
 */
IntersectionObserver.prototype._initThresholds = function(opt_threshold) {
  var threshold = opt_threshold || [0];
  if (!Array.isArray(threshold)) threshold = [threshold];

  return threshold.sort().filter(function(t, i, a) {
    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {
      throw new Error('threshold must be a number between 0 and 1 inclusively');
    }
    return t !== a[i - 1];
  });
};


/**
 * Accepts the rootMargin value from the user configuration object
 * and returns an array of the four margin values as an object containing
 * the value and unit properties. If any of the values are not properly
 * formatted or use a unit other than px or %, and error is thrown.
 * @private
 * @param {string=} opt_rootMargin An optional rootMargin value,
 *     defaulting to '0px'.
 * @return {Array<Object>} An array of margin objects with the keys
 *     value and unit.
 */
IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {
  var marginString = opt_rootMargin || '0px';
  var margins = marginString.split(/\s+/).map(function(margin) {
    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);
    if (!parts) {
      throw new Error('rootMargin must be specified in pixels or percent');
    }
    return {value: parseFloat(parts[1]), unit: parts[2]};
  });

  // Handles shorthand.
  margins[1] = margins[1] || margins[0];
  margins[2] = margins[2] || margins[0];
  margins[3] = margins[3] || margins[1];

  return margins;
};


/**
 * Starts polling for intersection changes if the polling is not already
 * happening, and if the page's visibility state is visible.
 * @private
 */
IntersectionObserver.prototype._monitorIntersections = function() {
  if (!this._monitoringIntersections) {
    this._monitoringIntersections = true;

    // If a poll interval is set, use polling instead of listening to
    // resize and scroll events or DOM mutations.
    if (this.POLL_INTERVAL) {
      this._monitoringInterval = setInterval(
          this._checkForIntersections, this.POLL_INTERVAL);
    }
    else {
      addEvent(window, 'resize', this._checkForIntersections, true);
      addEvent(document, 'scroll', this._checkForIntersections, true);

      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {
        this._domObserver = new MutationObserver(this._checkForIntersections);
        this._domObserver.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
  }
};


/**
 * Stops polling for intersection changes.
 * @private
 */
IntersectionObserver.prototype._unmonitorIntersections = function() {
  if (this._monitoringIntersections) {
    this._monitoringIntersections = false;

    clearInterval(this._monitoringInterval);
    this._monitoringInterval = null;

    removeEvent(window, 'resize', this._checkForIntersections, true);
    removeEvent(document, 'scroll', this._checkForIntersections, true);

    if (this._domObserver) {
      this._domObserver.disconnect();
      this._domObserver = null;
    }
  }
};


/**
 * Scans each observation target for intersection changes and adds them
 * to the internal entries queue. If new entries are found, it
 * schedules the callback to be invoked.
 * @private
 */
IntersectionObserver.prototype._checkForIntersections = function() {
  var rootIsInDom = this._rootIsInDom();
  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();

  this._observationTargets.forEach(function(item) {
    var target = item.element;
    var targetRect = getBoundingClientRect(target);
    var rootContainsTarget = this._rootContainsTarget(target);
    var oldEntry = item.entry;
    var intersectionRect = rootIsInDom && rootContainsTarget &&
        this._computeTargetAndRootIntersection(target, rootRect);

    var newEntry = item.entry = new IntersectionObserverEntry({
      time: now(),
      target: target,
      boundingClientRect: targetRect,
      rootBounds: rootRect,
      intersectionRect: intersectionRect
    });

    if (!oldEntry) {
      this._queuedEntries.push(newEntry);
    } else if (rootIsInDom && rootContainsTarget) {
      // If the new entry intersection ratio has crossed any of the
      // thresholds, add a new entry.
      if (this._hasCrossedThreshold(oldEntry, newEntry)) {
        this._queuedEntries.push(newEntry);
      }
    } else {
      // If the root is not in the DOM or target is not contained within
      // root but the previous entry for this target had an intersection,
      // add a new record indicating removal.
      if (oldEntry && oldEntry.isIntersecting) {
        this._queuedEntries.push(newEntry);
      }
    }
  }, this);

  if (this._queuedEntries.length) {
    this._callback(this.takeRecords(), this);
  }
};


/**
 * Accepts a target and root rect computes the intersection between then
 * following the algorithm in the spec.
 * TODO(philipwalton): at this time clip-path is not considered.
 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo
 * @param {Element} target The target DOM element
 * @param {Object} rootRect The bounding rect of the root after being
 *     expanded by the rootMargin value.
 * @return {?Object} The final intersection rect object or undefined if no
 *     intersection is found.
 * @private
 */
IntersectionObserver.prototype._computeTargetAndRootIntersection =
    function(target, rootRect) {

  // If the element isn't displayed, an intersection can't happen.
  if (window.getComputedStyle(target).display == 'none') return;

  var targetRect = getBoundingClientRect(target);
  var intersectionRect = targetRect;
  var parent = getParentNode(target);
  var atRoot = false;

  while (!atRoot) {
    var parentRect = null;
    var parentComputedStyle = parent.nodeType == 1 ?
        window.getComputedStyle(parent) : {};

    // If the parent isn't displayed, an intersection can't happen.
    if (parentComputedStyle.display == 'none') return;

    if (parent == this.root || parent == document) {
      atRoot = true;
      parentRect = rootRect;
    } else {
      // If the element has a non-visible overflow, and it's not the <body>
      // or <html> element, update the intersection rect.
      // Note: <body> and <html> cannot be clipped to a rect that's not also
      // the document rect, so no need to compute a new intersection.
      if (parent != document.body &&
          parent != document.documentElement &&
          parentComputedStyle.overflow != 'visible') {
        parentRect = getBoundingClientRect(parent);
      }
    }

    // If either of the above conditionals set a new parentRect,
    // calculate new intersection data.
    if (parentRect) {
      intersectionRect = computeRectIntersection(parentRect, intersectionRect);

      if (!intersectionRect) break;
    }
    parent = getParentNode(parent);
  }
  return intersectionRect;
};


/**
 * Returns the root rect after being expanded by the rootMargin value.
 * @return {Object} The expanded root rect.
 * @private
 */
IntersectionObserver.prototype._getRootRect = function() {
  var rootRect;
  if (this.root) {
    rootRect = getBoundingClientRect(this.root);
  } else {
    // Use <html>/<body> instead of window since scroll bars affect size.
    var html = document.documentElement;
    var body = document.body;
    rootRect = {
      top: 0,
      left: 0,
      right: html.clientWidth || body.clientWidth,
      width: html.clientWidth || body.clientWidth,
      bottom: html.clientHeight || body.clientHeight,
      height: html.clientHeight || body.clientHeight
    };
  }
  return this._expandRectByRootMargin(rootRect);
};


/**
 * Accepts a rect and expands it by the rootMargin value.
 * @param {Object} rect The rect object to expand.
 * @return {Object} The expanded rect.
 * @private
 */
IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {
  var margins = this._rootMarginValues.map(function(margin, i) {
    return margin.unit == 'px' ? margin.value :
        margin.value * (i % 2 ? rect.width : rect.height) / 100;
  });
  var newRect = {
    top: rect.top - margins[0],
    right: rect.right + margins[1],
    bottom: rect.bottom + margins[2],
    left: rect.left - margins[3]
  };
  newRect.width = newRect.right - newRect.left;
  newRect.height = newRect.bottom - newRect.top;

  return newRect;
};


/**
 * Accepts an old and new entry and returns true if at least one of the
 * threshold values has been crossed.
 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a
 *    particular target element or null if no previous entry exists.
 * @param {IntersectionObserverEntry} newEntry The current entry for a
 *    particular target element.
 * @return {boolean} Returns true if a any threshold has been crossed.
 * @private
 */
IntersectionObserver.prototype._hasCrossedThreshold =
    function(oldEntry, newEntry) {

  // To make comparing easier, an entry that has a ratio of 0
  // but does not actually intersect is given a value of -1
  var oldRatio = oldEntry && oldEntry.isIntersecting ?
      oldEntry.intersectionRatio || 0 : -1;
  var newRatio = newEntry.isIntersecting ?
      newEntry.intersectionRatio || 0 : -1;

  // Ignore unchanged ratios
  if (oldRatio === newRatio) return;

  for (var i = 0; i < this.thresholds.length; i++) {
    var threshold = this.thresholds[i];

    // Return true if an entry matches a threshold or if the new ratio
    // and the old ratio are on the opposite sides of a threshold.
    if (threshold == oldRatio || threshold == newRatio ||
        threshold < oldRatio !== threshold < newRatio) {
      return true;
    }
  }
};


/**
 * Returns whether or not the root element is an element and is in the DOM.
 * @return {boolean} True if the root element is an element and is in the DOM.
 * @private
 */
IntersectionObserver.prototype._rootIsInDom = function() {
  return !this.root || containsDeep(document, this.root);
};


/**
 * Returns whether or not the target element is a child of root.
 * @param {Element} target The target element to check.
 * @return {boolean} True if the target element is a child of root.
 * @private
 */
IntersectionObserver.prototype._rootContainsTarget = function(target) {
  return containsDeep(this.root || document, target);
};


/**
 * Adds the instance to the global IntersectionObserver registry if it isn't
 * already present.
 * @private
 */
IntersectionObserver.prototype._registerInstance = function() {
  if (registry.indexOf(this) < 0) {
    registry.push(this);
  }
};


/**
 * Removes the instance from the global IntersectionObserver registry.
 * @private
 */
IntersectionObserver.prototype._unregisterInstance = function() {
  var index = registry.indexOf(this);
  if (index != -1) registry.splice(index, 1);
};


/**
 * Returns the result of the performance.now() method or null in browsers
 * that don't support the API.
 * @return {number} The elapsed time since the page was requested.
 */
function now() {
  return window.performance && performance.now && performance.now();
}


/**
 * Throttles a function and delays its execution, so it's only called at most
 * once within a given time period.
 * @param {Function} fn The function to throttle.
 * @param {number} timeout The amount of time that must pass before the
 *     function can be called again.
 * @return {Function} The throttled function.
 */
function throttle(fn, timeout) {
  var timer = null;
  return function () {
    if (!timer) {
      timer = setTimeout(function() {
        fn();
        timer = null;
      }, timeout);
    }
  };
}


/**
 * Adds an event handler to a DOM node ensuring cross-browser compatibility.
 * @param {Node} node The DOM node to add the event handler to.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to add.
 * @param {boolean} opt_useCapture Optionally adds the even to the capture
 *     phase. Note: this only works in modern browsers.
 */
function addEvent(node, event, fn, opt_useCapture) {
  if (typeof node.addEventListener == 'function') {
    node.addEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.attachEvent == 'function') {
    node.attachEvent('on' + event, fn);
  }
}


/**
 * Removes a previously added event handler from a DOM node.
 * @param {Node} node The DOM node to remove the event handler from.
 * @param {string} event The event name.
 * @param {Function} fn The event handler to remove.
 * @param {boolean} opt_useCapture If the event handler was added with this
 *     flag set to true, it should be set to true here in order to remove it.
 */
function removeEvent(node, event, fn, opt_useCapture) {
  if (typeof node.removeEventListener == 'function') {
    node.removeEventListener(event, fn, opt_useCapture || false);
  }
  else if (typeof node.detatchEvent == 'function') {
    node.detatchEvent('on' + event, fn);
  }
}


/**
 * Returns the intersection between two rect objects.
 * @param {Object} rect1 The first rect.
 * @param {Object} rect2 The second rect.
 * @return {?Object} The intersection rect or undefined if no intersection
 *     is found.
 */
function computeRectIntersection(rect1, rect2) {
  var top = Math.max(rect1.top, rect2.top);
  var bottom = Math.min(rect1.bottom, rect2.bottom);
  var left = Math.max(rect1.left, rect2.left);
  var right = Math.min(rect1.right, rect2.right);
  var width = right - left;
  var height = bottom - top;

  return (width >= 0 && height >= 0) && {
    top: top,
    bottom: bottom,
    left: left,
    right: right,
    width: width,
    height: height
  };
}


/**
 * Shims the native getBoundingClientRect for compatibility with older IE.
 * @param {Element} el The element whose bounding rect to get.
 * @return {Object} The (possibly shimmed) rect of the element.
 */
function getBoundingClientRect(el) {
  var rect;

  try {
    rect = el.getBoundingClientRect();
  } catch (err) {
    // Ignore Windows 7 IE11 "Unspecified error"
    // https://github.com/w3c/IntersectionObserver/pull/205
  }

  if (!rect) return getEmptyRect();

  // Older IE
  if (!(rect.width && rect.height)) {
    rect = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      width: rect.right - rect.left,
      height: rect.bottom - rect.top
    };
  }
  return rect;
}


/**
 * Returns an empty rect object. An empty rect is returned when an element
 * is not in the DOM.
 * @return {Object} The empty rect.
 */
function getEmptyRect() {
  return {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0
  };
}

/**
 * Checks to see if a parent element contains a child element (including inside
 * shadow DOM).
 * @param {Node} parent The parent element.
 * @param {Node} child The child element.
 * @return {boolean} True if the parent node contains the child node.
 */
function containsDeep(parent, child) {
  var node = child;
  while (node) {
    if (node == parent) return true;

    node = getParentNode(node);
  }
  return false;
}


/**
 * Gets the parent node of an element or its host element if the parent node
 * is a shadow root.
 * @param {Node} node The node whose parent to get.
 * @return {Node|null} The parent node or null if no parent exists.
 */
function getParentNode(node) {
  var parent = node.parentNode;

  if (parent && parent.nodeType == 11 && parent.host) {
    // If the parent is a shadow root, return the host element.
    return parent.host;
  }

  if (parent && parent.assignedSlot) {
    // If the parent is distributed in a <slot>, return the parent of a slot.
    return parent.assignedSlot.parentNode;
  }

  return parent;
}


// Exposes the constructors globally.
window.IntersectionObserver = IntersectionObserver;
window.IntersectionObserverEntry = IntersectionObserverEntry;

}());

},{}],15:[function(require,module,exports){
(function(e,r){typeof exports==="object"&&typeof module!=="undefined"?r(exports):typeof define==="function"&&define.amd?define(["exports"],r):(e=e||self,r(e.stylis={}))})(this,(function(e){"use strict";var r="-ms-";var a="-moz-";var c="-webkit-";var t="comm";var n="rule";var s="decl";var i="@page";var u="@media";var o="@import";var f="@charset";var l="@viewport";var h="@supports";var p="@document";var v="@namespace";var b="@keyframes";var m="@font-face";var w="@counter-style";var d="@font-feature-values";var $=Math.abs;var k=String.fromCharCode;function g(e,r){return(((r<<2^A(e,0))<<2^A(e,1))<<2^A(e,2))<<2^A(e,3)}function x(e){return e.trim()}function E(e,r){return(e=r.exec(e))?e[0]:e}function y(e,r,a){return e.replace(r,a)}function T(e,r){return e.indexOf(r)}function A(e,r){return e.charCodeAt(r)|0}function O(e,r,a){return e.slice(r,a)}function M(e){return e.length}function C(e){return e.length}function S(e,r){return r.push(e),e}function R(e,r){return e.map(r).join("")}e.line=1;e.column=1;e.length=0;e.position=0;e.character=0;e.characters="";function z(r,a,c,t,n,s,i){return{value:r,root:a,parent:c,type:t,props:n,children:s,line:e.line,column:e.column,length:i,return:""}}function N(e,r,a){return z(e,r.root,r.parent,a,r.props,r.children,0)}function P(){return e.character}function U(){e.character=e.position>0?A(e.characters,--e.position):0;if(e.column--,e.character===10)e.column=1,e.line--;return e.character}function _(){e.character=e.position<e.length?A(e.characters,e.position++):0;if(e.column++,e.character===10)e.column=1,e.line++;return e.character}function j(){return A(e.characters,e.position)}function F(){return e.position}function I(r,a){return O(e.characters,r,a)}function L(e){switch(e){case 0:case 9:case 10:case 13:case 32:return 5;case 33:case 43:case 44:case 47:case 62:case 64:case 126:case 59:case 123:case 125:return 4;case 58:return 3;case 34:case 39:case 40:case 91:return 2;case 41:case 93:return 1}return 0}function D(r){return e.line=e.column=1,e.length=M(e.characters=r),e.position=0,[]}function K(r){return e.characters="",r}function V(r){return x(I(e.position-1,H(r===91?r+2:r===40?r+1:r)))}function W(e){return K(B(D(e)))}function Y(r){while(e.character=j())if(e.character<33)_();else break;return L(r)>2||L(e.character)>3?"":" "}function B(r){while(_())switch(L(e.character)){case 0:S(q(e.position-1),r);break;case 2:S(V(e.character),r);break;default:S(k(e.character),r)}return r}function G(r,a){while(--a&&_())if(e.character<48||e.character>102||e.character>57&&e.character<65||e.character>70&&e.character<97)break;return I(r,F()+(a<6&&j()==32&&_()==32))}function H(r){while(_())switch(e.character){case r:return e.position;case 34:case 39:return H(r===34||r===39?r:e.character);case 40:if(r===41)H(r);break;case 92:_();break}return e.position}function Z(r,a){while(_())if(r+e.character===47+10)break;else if(r+e.character===42+42&&j()===47)break;return"/*"+I(a,e.position-1)+"*"+k(r===47?r:_())}function q(r){while(!L(j()))_();return I(r,e.position)}function J(e){return K(Q("",null,null,null,[""],e=D(e),0,[0],e))}function Q(e,r,a,c,t,n,s,i,u){var o=0;var f=0;var l=s;var h=0;var p=0;var v=0;var b=1;var m=1;var w=1;var d=0;var $="";var g=t;var x=n;var E=c;var T=$;while(m)switch(v=d,d=_()){case 34:case 39:case 91:case 40:T+=V(d);break;case 9:case 10:case 13:case 32:T+=Y(v);break;case 92:T+=G(F()-1,7);continue;case 47:switch(j()){case 42:case 47:S(ee(Z(_(),F()),r,a),u);break;default:T+="/"}break;case 123*b:i[o++]=M(T)*w;case 125*b:case 59:case 0:switch(d){case 0:case 125:m=0;case 59+f:if(p>0&&M(T)-l)S(p>32?re(T+";",c,a,l-1):re(y(T," ","")+";",c,a,l-2),u);break;case 59:T+=";";default:S(E=X(T,r,a,o,f,t,i,$,g=[],x=[],l),n);if(d===123)if(f===0)Q(T,r,E,E,g,n,l,i,x);else switch(h){case 100:case 109:case 115:Q(e,E,E,c&&S(X(e,E,E,0,0,t,i,$,t,g=[],l),x),t,x,l,i,c?g:x);break;default:Q(T,E,E,E,[""],x,l,i,x)}}o=f=p=0,b=w=1,$=T="",l=s;break;case 58:l=1+M(T),p=v;default:if(b<1)if(d==123)--b;else if(d==125&&b++==0&&U()==125)continue;switch(T+=k(d),d*b){case 38:w=f>0?1:(T+="\f",-1);break;case 44:i[o++]=(M(T)-1)*w,w=1;break;case 64:if(j()===45)T+=V(_());h=j(),f=M($=T+=q(F())),d++;break;case 45:if(v===45&&M(T)==2)b=0}}return n}function X(e,r,a,c,t,s,i,u,o,f,l){var h=t-1;var p=t===0?s:[""];var v=C(p);for(var b=0,m=0,w=0;b<c;++b)for(var d=0,k=O(e,h+1,h=$(m=i[b])),g=e;d<v;++d)if(g=x(m>0?p[d]+" "+k:y(k,/&\f/g,p[d])))o[w++]=g;return z(e,r,a,t===0?n:u,o,f,l)}function ee(e,r,a){return z(e,r,a,t,k(P()),O(e,2,-2),0)}function re(e,r,a,c){return z(e,r,a,s,O(e,0,c),O(e,c+1,-1),c)}function ae(e,t){switch(g(e,t)){case 5103:return c+"print-"+e+e;case 5737:case 4201:case 3177:case 3433:case 1641:case 4457:case 2921:case 5572:case 6356:case 5844:case 3191:case 6645:case 3005:case 6391:case 5879:case 5623:case 6135:case 4599:case 4855:case 4215:case 6389:case 5109:case 5365:case 5621:case 3829:return c+e+e;case 5349:case 4246:case 4810:case 6968:case 2756:return c+e+a+e+r+e+e;case 6828:case 4268:return c+e+r+e+e;case 6165:return c+e+r+"flex-"+e+e;case 5187:return c+e+y(e,/(\w+).+(:[^]+)/,c+"box-$1$2"+r+"flex-$1$2")+e;case 5443:return c+e+r+"flex-item-"+y(e,/flex-|-self/,"")+e;case 4675:return c+e+r+"flex-line-pack"+y(e,/align-content|flex-|-self/,"")+e;case 5548:return c+e+r+y(e,"shrink","negative")+e;case 5292:return c+e+r+y(e,"basis","preferred-size")+e;case 6060:return c+"box-"+y(e,"-grow","")+c+e+r+y(e,"grow","positive")+e;case 4554:return c+y(e,/([^-])(transform)/g,"$1"+c+"$2")+e;case 6187:return y(y(y(e,/(zoom-|grab)/,c+"$1"),/(image-set)/,c+"$1"),e,"")+e;case 5495:case 3959:return y(e,/(image-set\([^]*)/,c+"$1"+"$`$1");case 4968:return y(y(e,/(.+:)(flex-)?(.*)/,c+"box-pack:$3"+r+"flex-pack:$3"),/s.+-b[^;]+/,"justify")+c+e+e;case 4095:case 3583:case 4068:case 2532:return y(e,/(.+)-inline(.+)/,c+"$1$2")+e;case 8116:case 7059:case 5753:case 5535:case 5445:case 5701:case 4933:case 4677:case 5533:case 5789:case 5021:case 4765:if(M(e)-1-t>6)switch(A(e,t+1)){case 109:if(A(e,t+4)!==45)break;case 102:return y(e,/(.+:)(.+)-([^]+)/,"$1"+c+"$2-$3"+"$1"+a+(A(e,t+3)==108?"$3":"$2-$3"))+e;case 115:return~T(e,"stretch")?ae(y(e,"stretch","fill-available"),t)+e:e}break;case 4949:if(A(e,t+1)!==115)break;case 6444:switch(A(e,M(e)-3-(~T(e,"!important")&&10))){case 107:return y(e,":",":"+c)+e;case 101:return y(e,/(.+:)([^;!]+)(;|!.+)?/,"$1"+c+(A(e,14)===45?"inline-":"")+"box$3"+"$1"+c+"$2$3"+"$1"+r+"$2box$3")+e}break;case 5936:switch(A(e,t+11)){case 114:return c+e+r+y(e,/[svh]\w+-[tblr]{2}/,"tb")+e;case 108:return c+e+r+y(e,/[svh]\w+-[tblr]{2}/,"tb-rl")+e;case 45:return c+e+r+y(e,/[svh]\w+-[tblr]{2}/,"lr")+e}return c+e+r+e+e}return e}function ce(e,r){var a="";var c=C(e);for(var t=0;t<c;t++)a+=r(e[t],t,e,r)||"";return a}function te(e,r,a,c){switch(e.type){case o:case s:return e.return=e.return||e.value;case t:return"";case n:e.value=e.props.join(",")}return M(a=ce(e.children,c))?e.return=e.value+"{"+a+"}":""}function ne(e){var r=C(e);return function(a,c,t,n){var s="";for(var i=0;i<r;i++)s+=e[i](a,c,t,n)||"";return s}}function se(e){return function(r){if(!r.root)if(r=r.return)e(r)}}function ie(e,t,i,u){if(!e.return)switch(e.type){case s:e.return=ae(e.value,e.length);break;case b:return ce([N(y(e.value,"@","@"+c),e,"")],u);case n:if(e.length)return R(e.props,(function(t){switch(E(t,/(::plac\w+|:read-\w+)/)){case":read-only":case":read-write":return ce([N(y(t,/:(read-\w+)/,":"+a+"$1"),e,"")],u);case"::placeholder":return ce([N(y(t,/:(plac\w+)/,":"+c+"input-$1"),e,""),N(y(t,/:(plac\w+)/,":"+a+"$1"),e,""),N(y(t,/:(plac\w+)/,r+"input-$1"),e,"")],u)}return""}))}}function ue(e){switch(e.type){case n:e.props=e.props.map((function(r){return R(W(r),(function(r,a,c){switch(A(r,0)){case 12:return O(r,1,M(r));case 0:case 40:case 43:case 62:case 126:return r;case 58:if(c[++a]==="global")c[a]="",c[++a]="\f"+O(c[a],a=1,-1);case 32:return a===1?"":r;default:switch(a){case 0:e=r;return C(c)>1?"":r;case a=C(c)-1:case 2:return a===2?r+e+e:r+e;default:return r}}}))}))}}e.CHARSET=f;e.COMMENT=t;e.COUNTER_STYLE=w;e.DECLARATION=s;e.DOCUMENT=p;e.FONT_FACE=m;e.FONT_FEATURE_VALUES=d;e.IMPORT=o;e.KEYFRAMES=b;e.MEDIA=u;e.MOZ=a;e.MS=r;e.NAMESPACE=v;e.PAGE=i;e.RULESET=n;e.SUPPORTS=h;e.VIEWPORT=l;e.WEBKIT=c;e.abs=$;e.alloc=D;e.append=S;e.caret=F;e.char=P;e.charat=A;e.combine=R;e.comment=ee;e.commenter=Z;e.compile=J;e.copy=N;e.dealloc=K;e.declaration=re;e.delimit=V;e.delimiter=H;e.escaping=G;e.from=k;e.hash=g;e.identifier=q;e.indexof=T;e.match=E;e.middleware=ne;e.namespace=ue;e.next=_;e.node=z;e.parse=Q;e.peek=j;e.prefix=ae;e.prefixer=ie;e.prev=U;e.replace=y;e.ruleset=X;e.rulesheet=se;e.serialize=ce;e.sizeof=C;e.slice=I;e.stringify=te;e.strlen=M;e.substr=O;e.token=L;e.tokenize=W;e.tokenizer=B;e.trim=x;e.whitespace=Y;Object.defineProperty(e,"__esModule",{value:true})}));


},{}],16:[function(require,module,exports){
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.throttleDebounce = {}));
}(this, (function (exports) { 'use strict';

	/* eslint-disable no-undefined,no-param-reassign,no-shadow */

	/**
	 * Throttle execution of a function. Especially useful for rate limiting
	 * execution of handlers on events like resize and scroll.
	 *
	 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
	 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
	 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
	 *                                    the internal counter is reset).
	 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                    to `callback` when the throttled-function is executed.
	 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
	 *                                    schedule `callback` to execute after `delay` ms.
	 *
	 * @returns {Function}  A new, throttled, function.
	 */
	function throttle (delay, noTrailing, callback, debounceMode) {
	  /*
	   * After wrapper has stopped being called, this timeout ensures that
	   * `callback` is executed at the proper times in `throttle` and `end`
	   * debounce modes.
	   */
	  var timeoutID;
	  var cancelled = false; // Keep track of the last time `callback` was executed.

	  var lastExec = 0; // Function to clear existing timeout

	  function clearExistingTimeout() {
	    if (timeoutID) {
	      clearTimeout(timeoutID);
	    }
	  } // Function to cancel next exec


	  function cancel() {
	    clearExistingTimeout();
	    cancelled = true;
	  } // `noTrailing` defaults to falsy.


	  if (typeof noTrailing !== 'boolean') {
	    debounceMode = callback;
	    callback = noTrailing;
	    noTrailing = undefined;
	  }
	  /*
	   * The `wrapper` function encapsulates all of the throttling / debouncing
	   * functionality and when executed will limit the rate at which `callback`
	   * is executed.
	   */


	  function wrapper() {
	    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
	      arguments_[_key] = arguments[_key];
	    }

	    var self = this;
	    var elapsed = Date.now() - lastExec;

	    if (cancelled) {
	      return;
	    } // Execute `callback` and update the `lastExec` timestamp.


	    function exec() {
	      lastExec = Date.now();
	      callback.apply(self, arguments_);
	    }
	    /*
	     * If `debounceMode` is true (at begin) this is used to clear the flag
	     * to allow future `callback` executions.
	     */


	    function clear() {
	      timeoutID = undefined;
	    }

	    if (debounceMode && !timeoutID) {
	      /*
	       * Since `wrapper` is being called for the first time and
	       * `debounceMode` is true (at begin), execute `callback`.
	       */
	      exec();
	    }

	    clearExistingTimeout();

	    if (debounceMode === undefined && elapsed > delay) {
	      /*
	       * In throttle mode, if `delay` time has been exceeded, execute
	       * `callback`.
	       */
	      exec();
	    } else if (noTrailing !== true) {
	      /*
	       * In trailing throttle mode, since `delay` time has not been
	       * exceeded, schedule `callback` to execute `delay` ms after most
	       * recent execution.
	       *
	       * If `debounceMode` is true (at begin), schedule `clear` to execute
	       * after `delay` ms.
	       *
	       * If `debounceMode` is false (at end), schedule `callback` to
	       * execute after `delay` ms.
	       */
	      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
	    }
	  }

	  wrapper.cancel = cancel; // Return the wrapper function.

	  return wrapper;
	}

	/* eslint-disable no-undefined */
	/**
	 * Debounce execution of a function. Debouncing, unlike throttling,
	 * guarantees that a function is only executed a single time, either at the
	 * very beginning of a series of calls, or at the very end.
	 *
	 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
	 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
	 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
	 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
	 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
	 *                                  to `callback` when the debounced-function is executed.
	 *
	 * @returns {Function} A new, debounced function.
	 */

	function debounce (delay, atBegin, callback) {
	  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
	}

	exports.debounce = debounce;
	exports.throttle = throttle;

	Object.defineProperty(exports, '__esModule', { value: true });

})));


},{}],17:[function(require,module,exports){
/**
 * [23卒バナー商品] Koruriターゲバナー用 共通処理管理JS
 */

'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

require('intersection-observer');

var _KoruliTargetBannerUtilities = require('./_KoruliTargetBannerUtilities');

var _throttleDebounce = require('throttle-debounce');

var API_URL_PROD = 'https://s9.r-ad.ne.jp/json';
var API_URL_STG = 'https://s9-stg.r-ad.ne.jp/json';

var API_CLIENT_CODE = '66.media_client';

// 吸着バナーを表示するスクロール量
var FIXED_SHOW_POSITION = 100;

/**
 * @description [23卒バナー商品] PC/SP共通 Koruli ターゲバナー表示処理
 * @param {string} bannerSelector - バナーDOM出力先のHTMLセレクタ名
 * @param {number} bannerNum - バナー表示数
 * @param {array} bannerSettings - 各画面のバナー設定情報オブジェクト配列
 */

var KoruliTargetBannerConfig = (function () {
  function KoruliTargetBannerConfig(_ref) {
    var bannerSelector = _ref.bannerSelector;
    var bannerNum = _ref.bannerNum;
    var bannerSettings = _ref.bannerSettings;

    _classCallCheck(this, KoruliTargetBannerConfig);

    if (!window.frontend) return;

    this.apiUrl = frontend.isKoruliHostProduction ? API_URL_PROD : API_URL_STG;

    // 生成したバナーDOMを出力する要素取得
    this.bannerSelector = bannerSelector;

    // パラメータ情報取得
    this.bannerNum = bannerNum;
    this.bannerSettings = bannerSettings;

    // 表示対象となる広告IDの取得
    this.koruliFrameId = frontend.koruliFrameId ? frontend.koruliFrameId : null;

    // Koruli APIで取得したバナー情報格納用
    this.bannerData = [];

    // 吸着バナー表示済み判定用フラグ
    this.isShowedFixedBanner = false;

    // ログ送信用変数取得
    this.s = window.s ? window.s : null;
    this.prop4 = this.__getProp4();
  }

  /**
   * @private
   * @param {function} callback - バナー情報取得の非同期処理が終わった際のcallback
   * @description ターゲバナー表示 初期処理
   */

  _createClass(KoruliTargetBannerConfig, [{
    key: '__getBannerInfo',
    value: function __getBannerInfo(callback) {
      var _this = this;

      // 広告IDが取得できなかった場合は何もしない
      if (!this.koruliFrameId) return;

      // koruli APIに渡すGETパラメータの設定
      var koruliParam = 'f=' + API_CLIENT_CODE + '.' + this.koruliFrameId + '&m=' + this.bannerNum;

      // liercoのkidを取得するための関数。callS9WithKidの名称変更不可
      var callS9WithKid = function callS9WithKid(kid) {
        _this.__getApiRequest(_this.apiUrl + '?' + koruliParam + '&kid=' + kid, function (data) {
          if (!data) return;

          _this.bannerData = [].concat(_toConsumableArray(data));

          // バナー情報が取得できた場合は表示して終了
          if (_this.bannerData.length) {
            callback();
            return;
          }

          // バナー件数が0件 かつ 共通リタゲ枠以外のリクエストだった場合は、共通リタゲ枠で再リクエスト
          if (_this.koruliFrameId !== _KoruliTargetBannerUtilities.BANNER_COMMON_CODE) {
            var resendKoruliParam = 'f=' + API_CLIENT_CODE + '.' + _KoruliTargetBannerUtilities.BANNER_COMMON_CODE + '&m=' + _this.bannerNum;
            _this.__getApiRequest(_this.apiUrl + '?' + resendKoruliParam + '&kid=' + kid, function (data) {
              if (!data) return;
              _this.bannerData = [].concat(_toConsumableArray(data));
              callback();
            });
          }
        });
      };

      // liercoのkidを取得して、広告をロード
      window.lec_get_token = window.lec_get_token || [];
      window.lec_get_token.push([1, callS9WithKid]);
    }

    /**
     * @private
     * @description バナー情報取得APIを叩いて、ターゲバナー情報リストを取得
     *  IEがPromise非サポートのためvanillaで実装（axiosもPromiseベースだから使えない）
     * @param {string} url - バナー情報取得API パラメータ込みURL
     * @param {function} callBack - APIリクエスト正常終了時のCallback関数
     */
  }, {
    key: '__getApiRequest',
    value: function __getApiRequest(url, callBack) {
      var xhr = new XMLHttpRequest();
      var method = 'GET';

      xhr.open(method, url, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === XMLHttpRequest.DONE) {
          var _status = xhr.status;
          if (_status === 0 || _status >= 200 && _status < 400) {
            // リクエスト正常終了時
            callBack(JSON.parse(xhr.response));
          } else {
            // リクエストエラー終了時
            console.error('Api Get Error');
          }
        }
      };
      xhr.send();
    }

    /**
     * @private
     * @description ログ送信処理定義
     */
  }, {
    key: '__bindSendLogEvent',
    value: function __bindSendLogEvent() {
      // クリックログ・バナーのimpログの送信処理設定
      this.__bindClickLogEvent();
      this.__bindScrollLogEvent();
    }

    /**
     * @private
     * @description クリックログ送信イベント処理定義
     */
  }, {
    key: '__bindClickLogEvent',
    value: function __bindClickLogEvent() {
      var _this2 = this;

      var eventTarget = document.querySelectorAll(this.bannerSelector + ' .' + _KoruliTargetBannerUtilities.BANNER_LINK_HOOK_CLASS);
      Array.prototype.forEach.call(eventTarget, function (element) {
        element.addEventListener('click', function (event) {
          var target = event.currentTarget;
          var logType = 'click';
          _this2.__sendLog(target, logType);
        });
      });
    }

    /**
     * @private
     * @description スクロールでのimpログ送信イベント処理定義
     */
  }, {
    key: '__bindScrollLogEvent',
    value: function __bindScrollLogEvent() {
      var _this3 = this;

      var eventTarget = document.querySelectorAll(this.bannerSelector + ' .' + _KoruliTargetBannerUtilities.BANNER_IMP_HOOK_CLASS);
      var logType = 'imp';

      var options = {
        rootMargin: '0px 0px -20% 0px',
        threshold: 0
      };
      var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          // 対象要素が画面上に表示されていない場合は何もしない
          if (!entry.isIntersecting) return;

          var target = entry.target;
          if (!target.classList.contains(_KoruliTargetBannerUtilities.BANNER_IMP_HOOK_CLASS)) return;

          _this3.__sendLog(target, logType);
          target.classList.remove(_KoruliTargetBannerUtilities.BANNER_IMP_HOOK_CLASS);
          observer.unobserve(target);
        });
      }, options);

      Array.prototype.forEach.call(eventTarget, function (element) {
        observer.observe(element);
      });
    }

    /**
     * @private
     * @description 掲載位置ごとのバナーHitログ送信処理定義
     * @param {HTMLElement} bannerElement - ログ送信対象バナー要素
     */
  }, {
    key: '__sendHitLog',
    value: function __sendHitLog(bannerElement) {
      var _this4 = this;

      var eventTarget = bannerElement.querySelectorAll('.' + _KoruliTargetBannerUtilities.BANNER_LINK_HOOK_CLASS);
      Array.prototype.forEach.call(eventTarget, function (element) {
        var logType = 'hit';
        _this4.__sendLog(element, logType);
      });
    }

    /**
     * @private
     * @description ログ送信処理
     * @param {HTMLElement} target - ログ送信対象要素
     * @param {string} logType - ログ種別テキスト（hit | imp | click）
     */
  }, {
    key: '__sendLog',
    value: function __sendLog(target, logType) {
      if (!this.s) return;

      var index = target.dataset.bannerIndex;
      var adId = target.dataset.bannerAdid;
      var logText = 'targetingbanner_' + logType + '_' + this.prop4 + '_' + index + '_' + this.koruliFrameId + '_' + adId;
      this.s.tl(target, 'o', logText);
    }

    /**
     * @private
     * @description 吸着バナー用 イベント処理定義
     */
  }, {
    key: '__bindFixedBannerEvent',
    value: function __bindFixedBannerEvent() {
      var _this5 = this;

      // 吸着バナーの閉じる処理
      var fixedBannerElement = document.querySelector('.js-fixedTargetBanner');
      if (fixedBannerElement) {
        var fixedBannerCloseTrigger = document.querySelector('.js-fixedTargetBannerClose');
        fixedBannerCloseTrigger.addEventListener('click', function (event) {
          fixedBannerElement.classList.add(_KoruliTargetBannerUtilities.BANNER_CLOSED_CLASS);

          var target = event.currentTarget;
          var logType = 'close';
          _this5.__sendLog(target, logType);
        });
      }

      document.addEventListener('scroll', (0, _throttleDebounce.throttle)(100, function () {
        // 既に吸着表示済みの場合は何もしない
        if (_this5.isShowedFixedBanner) return;

        _this5.positionTop = window.pageYOffset;
        if (_this5.positionTop > FIXED_SHOW_POSITION) {
          fixedBannerElement.classList.remove(_KoruliTargetBannerUtilities.BANNER_CLOSED_CLASS);

          // 吸着バナー表示を行ったらimpログ送信
          var logTarget = fixedBannerElement.querySelector('.' + _KoruliTargetBannerUtilities.BANNER_LINK_HOOK_CLASS);
          var logType = 'imp';
          _this5.__sendLog(logTarget, logType);

          _this5.isShowedFixedBanner = true;
        }
      }));
    }

    /**
     * @private
     * @description ログ送信用のprop4の取得
     */
  }, {
    key: '__getProp4',
    value: function __getProp4() {
      var hasProp4 = this.s ? this.s.prop4 && this.s.prop4 !== 'void' && typeof this.s.prop4 !== 'undefined' : false;

      // 画面ID（prop4）が未定義の場合は、URLのパスを使う
      var prop4 = hasProp4 ? this.s.prop4 : location.pathname.split('/').filter(function (item) {
        return item;
      }).join('/');

      // カスタムリンクの区切り文字とかぶるため、「_」を除去して返却する
      return prop4.replace(/_/g, '');
    }
  }]);

  return KoruliTargetBannerConfig;
})();

exports.KoruliTargetBannerConfig = KoruliTargetBannerConfig;

},{"./_KoruliTargetBannerUtilities":18,"intersection-observer":14,"throttle-debounce":16}],18:[function(require,module,exports){
/**
 * [23卒バナー商品] Koruriターゲバナー用 定数管理用JS
 */

/*---- 定数定義 ----*/
// バナー種別（WF内コンポーネント検討に記載のバナー種別を踏襲）
// PC/SP共にカセット大が基準バナー。本文の有無は、各画面JSでバナー実装を呼び出す際の
// PCは右カラム用の小さい縦組みバナーがカセット小 Aパターン、カセット大の高さを控えた版がカセット小 Bパターン
// SPは
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var BANNER_TYPES = {
  FIXED: 'fixed', // 吸着バナー
  CASSETTE_MAIN: 'cassette-main', // カセットメイン
  CASSETTE_SMALL_A: 'cassette-small-a', // カセット小 Aパターン
  CASSETTE_SMALL_B: 'cassette-small-b', // カセット小 Bパターン
  CASSETTE_SMALL_C: 'cassette-small-c', // カセット小 Cパターン
  CASSETTE_LARGE: 'cassette-large' };

// タイトル・横並びバナーのalign設定
// カセット大
var ALIGN_TYPES = {
  CENTER: 'center', // 中央寄せ
  LEFT: 'left' };

// バナー枠のタイトル種別
// SPは文字サイズ小のタイトルがないので、文字サイズ小を指定した場合は標準文字サイズを表示
// 左寄せ
var TITLE_TYPES = {
  NORMAL: 'normal', // 標準文字サイズ
  FONT_LARGE: 'font-large', // 文字サイズ大
  FONT_SMALL: 'font-small', // 文字サイズ小
  FONT_SMALL_RIGHT_COLUMN: 'font-small-right-column', // 文字サイズ小 PC右カラム用タイトル
  JOURNAL: 'font-journal', // 高校生なう用タイトル
  NONE: 'none' };

// バナー枠の背景色種別
// タイトルなし
var BACKGROUND_TYPES = {
  NONE: 'none', // 背景色なし(白ではなく背景色設定なし、background-color: transparent)
  LIGHT_BLUE: 'light-blue', // 背景色ブルー（Bg_Ultralight_Blue: #e7f6ff）
  SAPURI_WHITE: 'sapuri-white', // 背景色薄グレー（Bg_Sapuri_White: #f8f9f9）
  WHITE: 'white', // 背景色白(#fff)
  WHITE_BOX: 'white-box' };

// 吸着バナー用 バナー非表示時用css class
// SPのみ使用。背景色白(#fff)、box-shadowあり
var BANNER_CLOSED_CLASS = 'is-closed';

// クリックログ用 フックclass
var BANNER_LINK_HOOK_CLASS = 'js-targetBannerLink';

// impログ用 フックclass
var BANNER_IMP_HOOK_CLASS = 'js-targetImpLog';

// 共通リタゲ枠 配信枠コード
var BANNER_COMMON_CODE = 'cf001';

exports.BANNER_TYPES = BANNER_TYPES;
exports.ALIGN_TYPES = ALIGN_TYPES;
exports.TITLE_TYPES = TITLE_TYPES;
exports.BACKGROUND_TYPES = BACKGROUND_TYPES;
exports.BANNER_CLOSED_CLASS = BANNER_CLOSED_CLASS;
exports.BANNER_LINK_HOOK_CLASS = BANNER_LINK_HOOK_CLASS;
exports.BANNER_IMP_HOOK_CLASS = BANNER_IMP_HOOK_CLASS;
exports.BANNER_COMMON_CODE = BANNER_COMMON_CODE;

},{}],19:[function(require,module,exports){
/**
 * [23卒バナー商品] PC/SP共通 バナー枠 背景色コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #e7f6ff;\n'], ['\n  background-color: #e7f6ff;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: #f8f9f9;\n'], ['\n  background-color: #f8f9f9;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background-color: #fff;\n'], ['\n  background-color: #fff;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n'], ['\n  background-color: #fff;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _KoruliTargetBannerUtilities = require('../_KoruliTargetBannerUtilities');

/*---- CSS定義 ----*/
var bgLightBlueStyles = (0, _emotionCss.css)(_templateObject);

var bgSapuriWhiteStyles = (0, _emotionCss.css)(_templateObject2);

var bgWhiteStyles = (0, _emotionCss.css)(_templateObject3);

var bgWhiteBoxStyles = (0, _emotionCss.css)(_templateObject4);

/**
 * @description バナー枠背景色の設定
 * @param {string} backgroundType - 背景色設定
 * @returns {css object} - バナー枠背景色のcss設定
 */
var getBackgroundStyles = function getBackgroundStyles(backgroundType) {
  // 呼び出し元から渡されたバナー表示タイプに基づいたバナーHTMLを出力
  switch (backgroundType) {
    case _KoruliTargetBannerUtilities.BACKGROUND_TYPES.LIGHT_BLUE:
      return bgLightBlueStyles;

    case _KoruliTargetBannerUtilities.BACKGROUND_TYPES.SAPURI_WHITE:
      return bgSapuriWhiteStyles;

    case _KoruliTargetBannerUtilities.BACKGROUND_TYPES.WHITE:
      return bgWhiteStyles;

    case _KoruliTargetBannerUtilities.BACKGROUND_TYPES.WHITE_BOX:
      return bgWhiteBoxStyles;

    default:
      return '';
  }
};

exports.getBackgroundStyles = getBackgroundStyles;

},{"../_KoruliTargetBannerUtilities":18,"@emotion/css":5}],20:[function(require,module,exports){
/**
 * [23卒バナー商品] PC バナー外枠 margin設定コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['', ''], ['', '']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

/**
 * @description バナー外枠のmargin設定
 * @param {string} outerMarginStyle - margin設定
 * @returns {css object} - バナー外枠marginのcss設定
 */
var getOuterMarginStyles = function getOuterMarginStyles() {
  var outerMarginStyle = arguments.length <= 0 || arguments[0] === undefined ? 'margin: 0 auto;' : arguments[0];

  // 呼び出し元から渡されたmargin設定をCSS化
  return (0, _emotionCss.css)(_templateObject, outerMarginStyle);
};

exports.getOuterMarginStyles = getOuterMarginStyles;

},{"@emotion/css":5}],21:[function(require,module,exports){
// class継承元のPC/SP共通バナー処理
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _KoruliTargetBannerConfig2 = require('../_KoruliTargetBannerConfig');

// バナーコンポーネント群のimport

var _koruliTargetBanner_FixedBanner = require('./koruliTargetBanner/_FixedBanner');

var _koruliTargetBanner_CassetteSmallA = require('./koruliTargetBanner/_CassetteSmallA');

var _koruliTargetBanner_CassetteMain = require('./koruliTargetBanner/_CassetteMain');

var _koruliTargetBanner_CassetteLarge = require('./koruliTargetBanner/_CassetteLarge');

var _KoruliTargetBannerUtilities = require('../_KoruliTargetBannerUtilities');

/**
 * @description [23卒バナー商品] Koruli PCターゲバナー HTML生成処理
 * @param {string} bannerSelector - バナーDOM出力先のHTMLセレクタ名
 * @param {number} bannerNum - バナー表示数
 * @param {array} bannerSettings - 各画面のバナー設定情報オブジェクト配列
 *   bannerSettings配列内のバナー設定情報オブジェクトについて
 *   - priority: [必須]バナーの表示優先度
 *   - bannerNum: [必須]対象枠のバナー表示数
 *   - bannerType: [必須]バナー種別
 *   - titleType: [任意]タイトル種別
 *   - alignType: [任意]align設定
 *   - backgroundType: [任意]背景色
 *   - outerMarginStyle: [任意]バナー枠外側のmargin設定
 *   - isShowDescription: [任意]カセット大の場合、本文表示を行うか
 *   - logIndexOffset: [任意]ログ送信値のindex箇所にOffset値を加算する。1画面で2度インスタンスを生成する場合などを想定。
 */

var KoruliTargetBannerPc = (function (_KoruliTargetBannerConfig) {
  _inherits(KoruliTargetBannerPc, _KoruliTargetBannerConfig);

  function KoruliTargetBannerPc(_ref) {
    var bannerSelector = _ref.bannerSelector;
    var bannerNum = _ref.bannerNum;
    var bannerSettings = _ref.bannerSettings;

    _classCallCheck(this, KoruliTargetBannerPc);

    _get(Object.getPrototypeOf(KoruliTargetBannerPc.prototype), 'constructor', this).call(this, {
      bannerSelector: bannerSelector,
      bannerNum: bannerNum,
      bannerSettings: bannerSettings
    });

    this.__init();
  }

  /**
   * @private
   * @description 初期処理
   */

  _createClass(KoruliTargetBannerPc, [{
    key: '__init',
    value: function __init() {
      var _this = this;

      this.__getBannerInfo(function () {
        // koruli APIから取得したデータを元にバナーDOMを出力
        _this.__setBannerDom();

        // 出力したバナーDOMにログ送信イベントを設定
        _this.__bindSendLogEvent();
      });
    }

    /**
     * @private
     * @description バナーDOMの生成・出力
     */
  }, {
    key: '__setBannerDom',
    value: function __setBannerDom() {
      var _this2 = this;

      var startIndex = 0;
      this.bannerSettings.forEach(function (data) {
        // 画面固有JSから受け取ったバナー設定を元に、APIで受け取ったデータから対象のバナー情報を抽出する
        var targetBannerList = [].concat(_toConsumableArray(_this2.bannerData)).splice(startIndex, data.bannerNum);

        // 必要数のバナー情報が取得できなかった場合など、対象枠に表示するバナー情報が取得できなかった場合は何もしない
        if (!targetBannerList.length) return;

        // 出力するバナーDOMを生成
        var logIndex = startIndex + 1 + (data.logIndexOffset ? data.logIndexOffset : 0);
        var bannerDom = _this2.__getBannerHtml(data, targetBannerList, logIndex);

        // バナーDOMを取得できなかった場合は終了
        if (!bannerDom) return;

        // HTMLタグのdata属性に設定されている表示優先度がバナー設定情報と一致している要素に対して、生成したバナーDOMを出力
        // ※複数の同じpriorityの箇所に、同じbannerDomを挿入したいケースに対応するためにquerySelectorAllにしています
        var bannerElements = document.querySelectorAll(_this2.bannerSelector + '[data-banner-priority="' + data.priority + '"]');
        Array.prototype.forEach.call(bannerElements, function (bannerElement, index) {
          bannerElement.insertAdjacentHTML('beforeend', bannerDom);

          // バナーHitログ送信（表示できたバナーの掲載個所No.を送信）※1カ所目のみ送信
          if (index === 0) {
            _this2.__sendHitLog(bannerElement);
          }
        });

        // バナー種別が吸着バナーの場合、吸着バナーイベントを設定
        // ※各画面に吸着バナーは1つしか存在しない前提でここに入れている
        if (data.bannerType === _KoruliTargetBannerUtilities.BANNER_TYPES.FIXED) _this2.__bindFixedBannerEvent();

        startIndex += data.bannerNum;
      });
    }

    /**
     * @private
     * @description 各種バナーHTMLの生成
     * @param {object} data - バナー設定情報
     * @param {array} targetBannerList - 表示対象のバナーデータ情報
     * @param {number} startIndex - 対象バナー枠内の最初の掲載個所No.
     * @returns {string} - 各種バナーのHTML DOM文字列
     */
  }, {
    key: '__getBannerHtml',
    value: function __getBannerHtml(data, targetBannerList, startIndex) {
      // 呼び出し元から渡されたバナー表示タイプに基づいたバナーHTMLを出力
      switch (data.bannerType) {
        case _KoruliTargetBannerUtilities.BANNER_TYPES.FIXED:
          return (0, _koruliTargetBanner_FixedBanner.fixedBannerHtml)(data, targetBannerList, startIndex);

        case _KoruliTargetBannerUtilities.BANNER_TYPES.CASSETTE_SMALL_A:
          return (0, _koruliTargetBanner_CassetteSmallA.cassetteSmallBannerHtml_A)(data, targetBannerList, startIndex);

        case _KoruliTargetBannerUtilities.BANNER_TYPES.CASSETTE_MAIN:
        case _KoruliTargetBannerUtilities.BANNER_TYPES.CASSETTE_SMALL_B:
          return (0, _koruliTargetBanner_CassetteMain.cassetteMainBannerHtml)(data, targetBannerList, startIndex);

        case _KoruliTargetBannerUtilities.BANNER_TYPES.CASSETTE_LARGE:
          return (0, _koruliTargetBanner_CassetteLarge.cassetteLargeBannerHtml)(data, targetBannerList, startIndex);

        default:
          return '';
      }
    }
  }]);

  return KoruliTargetBannerPc;
})(_KoruliTargetBannerConfig2.KoruliTargetBannerConfig);

exports.KoruliTargetBannerPc = KoruliTargetBannerPc;

},{"../_KoruliTargetBannerConfig":17,"../_KoruliTargetBannerUtilities":18,"./koruliTargetBanner/_CassetteLarge":22,"./koruliTargetBanner/_CassetteMain":23,"./koruliTargetBanner/_CassetteSmallA":24,"./koruliTargetBanner/_FixedBanner":25}],22:[function(require,module,exports){
/**
 * [23卒バナー商品] PC カセット大コンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding: 24px 40px;\n  max-width: 960px;\n  text-align: left;\n'], ['\n  box-sizing: border-box;\n  padding: 24px 40px;\n  max-width: 960px;\n  text-align: left;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 16px auto 0;\n  overflow: hidden;\n  width: 100%;\n  max-width: 680px;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n'], ['\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 16px auto 0;\n  overflow: hidden;\n  width: 100%;\n  max-width: 680px;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  text-decoration: none;\n\n  &:hover {\n    opacity: 0.8;\n    text-decoration: none;\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n'], ['\n  display: flex;\n  text-decoration: none;\n\n  &:hover {\n    opacity: 0.8;\n    text-decoration: none;\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  height: 152px;\n  width: 290px;\n  overflow: hidden;\n'], ['\n  height: 152px;\n  width: 290px;\n  overflow: hidden;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  height: 152px;\n  width: 290px;\n'], ['\n  height: 152px;\n  width: 290px;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding: 16px;\n  width: calc(100% - 290px);\n'], ['\n  box-sizing: border-box;\n  padding: 16px;\n  width: calc(100% - 290px);\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  margin-bottom: 12px;\n'], ['\n  margin-bottom: 12px;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0 0 4px;\n'], ['\n  color: #0b41a0;\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0 0 4px;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  color: #24243f;\n  font-size: 12px;\n  margin: 0;\n'], ['\n  color: #24243f;\n  font-size: 12px;\n  margin: 0;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  color: #808d96;\n  font-size: 14px;\n  font-weight: bold;\n  margin: 0 0 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  color: #808d96;\n  font-size: 14px;\n  font-weight: bold;\n  margin: 0 0 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n  color: #808d96;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  color: #808d96;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n  padding-top: 0;\n  padding-bottom: 0;\n'], ['\n  padding-top: 0;\n  padding-bottom: 0;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _KoruliTargetBannerUtilities = require('../../_KoruliTargetBannerUtilities');

var _Title = require('./_Title');

var _koruliTargetBanner_Background = require('../../koruliTargetBanner/_Background');

var _koruliTargetBanner_OuterMargin = require('../../koruliTargetBanner/_OuterMargin');

/*---- CSS定義 ----*/
var bannerStyles = (0, _emotionCss.css)(_templateObject);

var bannerListStyles = (0, _emotionCss.css)(_templateObject2);

var bannerItemStyles = (0, _emotionCss.css)(_templateObject3);

var bannerLinkStyles = (0, _emotionCss.css)(_templateObject4);

var bannerImageBlockStyles = (0, _emotionCss.css)(_templateObject5);

var bannerImageStyles = (0, _emotionCss.css)(_templateObject6);

var bannerInfoStyles = (0, _emotionCss.css)(_templateObject7);

var bannerTitleBlockStyles = (0, _emotionCss.css)(_templateObject8);

var bannerTitleStyles = (0, _emotionCss.css)(_templateObject9);

var bannerDescriptionStyles = (0, _emotionCss.css)(_templateObject10);

var bannerNameStyles = (0, _emotionCss.css)(_templateObject11);

var bannerOtherInfoStyles = (0, _emotionCss.css)(_templateObject12);

var bgNonePaddingStyles = (0, _emotionCss.css)(_templateObject13);

var descriptionHtml = function descriptionHtml(description) {
  return '<div class="' + bannerDescriptionStyles + '">' + description + '</div>';
};

/*---- バナーフォーマット定義 ----*/

/**
 * @description カセット大バナーDOMの生成
 * @param {object} data - バナー設定情報
 * @param {array} targetBannerList - 表示対象のバナーデータ情報
 * @param {number} index - バナー枠内の最初の掲載個所No.
 * @returns {string} - カセット大バナー枠コンポーネントのHTML DOM文字列
 */
var cassetteLargeBannerHtml = function cassetteLargeBannerHtml(data, targetBannerList, index) {
  var titleHtml = (0, _Title.createBannerTitleHtml)(data.titleType, data.alignType);
  var bgStyles = (0, _koruliTargetBanner_Background.getBackgroundStyles)(data.backgroundType);
  var outerMarginStyles = (0, _koruliTargetBanner_OuterMargin.getOuterMarginStyles)(data.outerMarginStyle);
  var paddingOption = data.backgroundType === _KoruliTargetBannerUtilities.BACKGROUND_TYPES.NONE ? bgNonePaddingStyles : '';

  var bannerHtml = '';
  targetBannerList.forEach(function (bannerData) {
    bannerHtml += __bannerCassetteHtml(bannerData.creative1, bannerData.redirect_url, bannerData.ad_id, bannerData.data, index, data.isShowDescription);
    index++;
  });

  return '\n    <div class="' + bannerStyles + ' ' + bgStyles + ' ' + outerMarginStyles + ' ' + paddingOption + '">\n      ' + titleHtml + '\n      <div class="' + bannerListStyles + '">\n        ' + bannerHtml + '\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description カセット大バナーの単体HTMLフォーマット生成
 * @param {string} bannerImage - バナー画像URL
 * @param {string} linkUrl - 遷移先URL
 * @param {string} adId - バナーの広告ID
 * @param {object} bannerData - バナー情報
 * @param {number} index - バナーの掲載個所No.
 * @param {boolean} isShowDescription - 本文を表示するか否か
 * @returns {string} - カセット大バナーの単体HTML DOM文字列
 */
var __bannerCassetteHtml = function __bannerCassetteHtml(bannerImage, linkUrl, adId, bannerData, index) {
  var isShowDescription = arguments.length <= 5 || arguments[5] === undefined ? false : arguments[5];

  var descriptionDomSetting = isShowDescription ? descriptionHtml(bannerData.text) : '';

  return '\n    <div class="' + bannerItemStyles + '">\n      <a\n        href="' + linkUrl + '"\n        class="' + bannerLinkStyles + ' ' + _KoruliTargetBannerUtilities.BANNER_LINK_HOOK_CLASS + ' ' + _KoruliTargetBannerUtilities.BANNER_IMP_HOOK_CLASS + '"\n        data-banner-index="' + index + '"\n        data-banner-adid="' + adId + '"\n        target="_blank"\n      >\n        <div class="' + bannerImageBlockStyles + '">\n          <img class="' + bannerImageStyles + '" src="' + bannerImage + '" alt="' + bannerData.title + '">\n        </div>\n        <div class="' + bannerInfoStyles + '">\n          <div class="' + bannerTitleBlockStyles + '">\n            <div class="' + bannerTitleStyles + '">' + bannerData.title + '</div>\n            ' + descriptionDomSetting + '\n          </div>\n          <div class="' + bannerNameStyles + '">' + bannerData.name + '</div>\n          <div class="' + bannerOtherInfoStyles + '">' + bannerData.category + '／' + bannerData.area + '</div>\n        </div>\n      </a>\n    </div>\n  ';
};

exports.cassetteLargeBannerHtml = cassetteLargeBannerHtml;

},{"../../_KoruliTargetBannerUtilities":18,"../../koruliTargetBanner/_Background":19,"../../koruliTargetBanner/_OuterMargin":20,"./_Title":26,"@emotion/css":5}],23:[function(require,module,exports){
/**
 * [23卒バナー商品] PC カセットメインパターンコンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding: 24px 40px;\n  max-width: 960px;\n  text-align: left;\n'], ['\n  box-sizing: border-box;\n  padding: 24px 40px;\n  max-width: 960px;\n  text-align: left;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-top: 8px;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 16px auto 0;\n  overflow: hidden;\n  width: 100%;\n  max-width: 680px;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n'], ['\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);\n  font-size: 12px;\n  line-height: 1.5;\n  margin: 16px auto 0;\n  overflow: hidden;\n  width: 100%;\n  max-width: 680px;\n\n  &:first-child {\n    margin-top: 0 !important;\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  text-decoration: none;\n\n  &:hover {\n    opacity: 0.8;\n    text-decoration: none;\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n'], ['\n  display: flex;\n  text-decoration: none;\n\n  &:hover {\n    opacity: 0.8;\n    text-decoration: none;\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  height: 124px;\n  width: 237px;\n  overflow: hidden;\n'], ['\n  height: 124px;\n  width: 237px;\n  overflow: hidden;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  height: 124px;\n  width: 237px;\n'], ['\n  height: 124px;\n  width: 237px;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  padding: 16px;\n  width: calc(100% - 237px);\n'], ['\n  box-sizing: border-box;\n  padding: 16px;\n  width: calc(100% - 237px);\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0 0 12px;\n'], ['\n  color: #0b41a0;\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0 0 12px;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  color: #808d96;\n  font-size: 14px;\n  font-weight: bold;\n  margin: 0 0 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  color: #808d96;\n  font-size: 14px;\n  font-weight: bold;\n  margin: 0 0 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  color: #808d96;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  color: #808d96;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  padding-top: 0;\n  padding-bottom: 0;\n'], ['\n  padding-top: 0;\n  padding-bottom: 0;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _KoruliTargetBannerUtilities = require('../../_KoruliTargetBannerUtilities');

var _Title = require('./_Title');

var _koruliTargetBanner_Background = require('../../koruliTargetBanner/_Background');

var _koruliTargetBanner_OuterMargin = require('../../koruliTargetBanner/_OuterMargin');

/*---- CSS定義 ----*/
var bannerStyles = (0, _emotionCss.css)(_templateObject);

var bannerListStyles = (0, _emotionCss.css)(_templateObject2);

var bannerItemStyles = (0, _emotionCss.css)(_templateObject3);

var bannerLinkStyles = (0, _emotionCss.css)(_templateObject4);

var bannerImageBlockStyles = (0, _emotionCss.css)(_templateObject5);

var bannerImageStyles = (0, _emotionCss.css)(_templateObject6);

var bannerInfoStyles = (0, _emotionCss.css)(_templateObject7);

var bannerTitleStyles = (0, _emotionCss.css)(_templateObject8);

var bannerNameStyles = (0, _emotionCss.css)(_templateObject9);

var bannerOtherInfoStyles = (0, _emotionCss.css)(_templateObject10);

var bgNonePaddingStyles = (0, _emotionCss.css)(_templateObject11);

/*---- バナーフォーマット定義 ----*/

/**
 * @description カセットメインパターンバナーDOMの生成
 * @param {object} data - バナー設定情報
 * @param {array} targetBannerList - 表示対象のバナーデータ情報
 * @param {number} index - バナー枠内の最初の掲載個所No.
 * @returns {string} - カセットメインパターンバナー枠コンポーネントのHTML DOM文字列
 */
var cassetteMainBannerHtml = function cassetteMainBannerHtml(data, targetBannerList, index) {
  var titleHtml = (0, _Title.createBannerTitleHtml)(data.titleType, data.alignType);
  var bgStyles = (0, _koruliTargetBanner_Background.getBackgroundStyles)(data.backgroundType);
  var outerMarginStyles = (0, _koruliTargetBanner_OuterMargin.getOuterMarginStyles)(data.outerMarginStyle);
  var paddingOption = data.backgroundType === _KoruliTargetBannerUtilities.BACKGROUND_TYPES.NONE ? bgNonePaddingStyles : '';

  var bannerHtml = '';
  targetBannerList.forEach(function (bannerData) {
    bannerHtml += __bannerCassetteHtml(bannerData.creative1, bannerData.redirect_url, bannerData.ad_id, bannerData.data, index);
    index++;
  });

  return '\n    <div class="' + bannerStyles + ' ' + bgStyles + ' ' + outerMarginStyles + ' ' + paddingOption + '">\n      ' + titleHtml + '\n      <div class="' + bannerListStyles + '">\n        ' + bannerHtml + '\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description カセットメインパターンバナーの単体HTMLフォーマット生成
 * @param {string} bannerImage - バナー画像URL
 * @param {string} linkUrl - 遷移先URL
 * @param {string} adId - バナーの広告ID
 * @param {object} bannerData - バナー情報
 * @param {number} index - バナーの掲載個所No.
 * @returns {string} - カセットメインパターンバナーの単体HTML DOM文字列
 */
var __bannerCassetteHtml = function __bannerCassetteHtml(bannerImage, linkUrl, adId, bannerData, index) {
  return '\n    <div class="' + bannerItemStyles + '">\n      <a\n        href="' + linkUrl + '"\n        class="' + bannerLinkStyles + ' ' + _KoruliTargetBannerUtilities.BANNER_LINK_HOOK_CLASS + ' ' + _KoruliTargetBannerUtilities.BANNER_IMP_HOOK_CLASS + '"\n        data-banner-index="' + index + '"\n        data-banner-adid="' + adId + '"\n        target="_blank"\n      >\n        <div class="' + bannerImageBlockStyles + '">\n          <img class="' + bannerImageStyles + '" src="' + bannerImage + '" alt="' + bannerData.title + '">\n        </div>\n        <div class="' + bannerInfoStyles + '">\n          <div class="' + bannerTitleStyles + '">' + bannerData.title + '</div>\n          <div class="' + bannerNameStyles + '">' + bannerData.name + '</div>\n          <div class="' + bannerOtherInfoStyles + '">' + bannerData.category + '／' + bannerData.area + '</div>\n        </div>\n      </a>\n    </div>\n  ';
};

exports.cassetteMainBannerHtml = cassetteMainBannerHtml;

},{"../../_KoruliTargetBannerUtilities":18,"../../koruliTargetBanner/_Background":19,"../../koruliTargetBanner/_OuterMargin":20,"./_Title":26,"@emotion/css":5}],24:[function(require,module,exports){
/**
 * [23卒バナー商品] PC カセット小 Aパターンコンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  padding: 16px 0 20px;\n  text-align: left;\n'], ['\n  padding: 16px 0 20px;\n  text-align: left;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n'], ['\n  display: flex;\n  flex-direction: column;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  line-height: 1.5;\n  margin: 20px auto 0;\n  overflow: hidden;\n  width: 152px;\n'], ['\n  line-height: 1.5;\n  margin: 20px auto 0;\n  overflow: hidden;\n  width: 152px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  text-decoration: none;\n\n  &:hover {\n    opacity: 0.8;\n    text-decoration: none;\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  text-decoration: none;\n\n  &:hover {\n    opacity: 0.8;\n    text-decoration: none;\n  }\n\n  &:link, &:visited {\n    text-decoration: none;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  height: 152px;\n  width: 152px;\n'], ['\n  height: 152px;\n  width: 152px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  font-size: 14px;\n  margin: 8px 0 0;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  color: #0b41a0;\n  font-size: 14px;\n  margin: 8px 0 0;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _KoruliTargetBannerUtilities = require('../../_KoruliTargetBannerUtilities');

var _Title = require('./_Title');

var _koruliTargetBanner_Background = require('../../koruliTargetBanner/_Background');

var _koruliTargetBanner_OuterMargin = require('../../koruliTargetBanner/_OuterMargin');

/*---- CSS定義 ----*/
var bannerStyles = (0, _emotionCss.css)(_templateObject);

var bannerListStyles = (0, _emotionCss.css)(_templateObject2);

var bannerItemStyles = (0, _emotionCss.css)(_templateObject3);

var bannerLinkStyles = (0, _emotionCss.css)(_templateObject4);

var bannerImageStyles = (0, _emotionCss.css)(_templateObject5);

var bannerOtherInfoStyles = (0, _emotionCss.css)(_templateObject6);

/*---- バナーフォーマット定義 ----*/

/**
 * @description カセット小 AパターンDOMの生成
 * @param {object} data - バナー設定情報
 * @param {array} targetBannerList - 表示対象のバナーデータ情報
 * @param {number} index - バナー枠内の最初の掲載個所No.
 * @returns {string} - カセット小 Aパターン枠コンポーネントのHTML DOM文字列
 */
var cassetteSmallBannerHtml_A = function cassetteSmallBannerHtml_A(data, targetBannerList, index) {
  var titleHtml = (0, _Title.createBannerTitleHtml)(data.titleType, data.alignType);
  var bgStyles = (0, _koruliTargetBanner_Background.getBackgroundStyles)(data.backgroundType);
  var outerMarginStyles = (0, _koruliTargetBanner_OuterMargin.getOuterMarginStyles)(data.outerMarginStyle);

  var bannerHtml = '';
  targetBannerList.forEach(function (bannerData) {
    bannerHtml += __bannerCassetteHtml(bannerData.creative2, bannerData.redirect_url, bannerData.ad_id, bannerData.data, index);
    index++;
  });

  return '\n    <div class="' + bannerStyles + ' ' + bgStyles + ' ' + outerMarginStyles + '">\n      ' + titleHtml + '\n      <div class="' + bannerListStyles + '">\n        ' + bannerHtml + '\n      </div>\n    </div>\n  ';
};

/**
 * @private
 * @description カセット小 Aパターンの単体HTMLフォーマット生成
 * @param {string} bannerImage - バナー画像URL
 * @param {string} linkUrl - 遷移先URL
 * @param {string} adId - バナーの広告ID
 * @param {object} bannerData - バナー情報
 * @param {number} index - バナーの掲載個所No.
 * @returns {string} - カセット小 Aパターンの単体HTML DOM文字列
 */
var __bannerCassetteHtml = function __bannerCassetteHtml(bannerImage, linkUrl, adId, bannerData, index) {
  return '\n    <div class="' + bannerItemStyles + '">\n      <a\n        href="' + linkUrl + '"\n        class="' + bannerLinkStyles + ' ' + _KoruliTargetBannerUtilities.BANNER_LINK_HOOK_CLASS + ' ' + _KoruliTargetBannerUtilities.BANNER_IMP_HOOK_CLASS + '"\n        data-banner-index="' + index + '"\n        data-banner-adid="' + adId + '"\n        target="_blank"\n      >\n        <img class="' + bannerImageStyles + '" src="' + bannerImage + '" alt="' + bannerData.title + '">\n        <div class="' + bannerOtherInfoStyles + '">' + bannerData.category + '／' + bannerData.area + '</div>\n      </a>\n    </div> \n  ';
};

exports.cassetteSmallBannerHtml_A = cassetteSmallBannerHtml_A;

},{"../../_KoruliTargetBannerUtilities":18,"../../koruliTargetBanner/_Background":19,"../../koruliTargetBanner/_OuterMargin":20,"./_Title":26,"@emotion/css":5}],25:[function(require,module,exports){
/**
 * [23卒バナー商品] PC 吸着バナーコンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.14);\n  margin: 0;\n  position: fixed;\n  bottom: 40px;\n  right: 40px;\n  width: 300px;\n  z-index: 1000;\n  text-align: left;\n\n  &.', ' {\n    display: none;\n  }\n'], ['\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.14);\n  margin: 0;\n  position: fixed;\n  bottom: 40px;\n  right: 40px;\n  width: 300px;\n  z-index: 1000;\n  text-align: left;\n\n  &.', ' {\n    display: none;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  display: block;\n  height: 32px;\n  position: absolute;\n  right: -16px;\n  top: -16px;\n  width: 32px;\n\n  &::before {\n    background: #808d96;\n    border-radius: 1px;\n    content: \'\';\n    display: block;\n    height: 2px;\n    position: absolute;\n    top: 16px;\n    right: 8px;\n    transform: rotate(-45deg);\n    width: 16px;\n  }\n\n  &::after {\n    background: #808d96;\n    border-radius: 1px;\n    content: \'\';\n    display: block;\n    height: 2px;\n    position: absolute;\n    top: 16px;\n    right: 8px;\n    transform: rotate(45deg);\n    width: 16px;\n  }\n'], ['\n  background-color: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n  cursor: pointer;\n  display: block;\n  height: 32px;\n  position: absolute;\n  right: -16px;\n  top: -16px;\n  width: 32px;\n\n  &::before {\n    background: #808d96;\n    border-radius: 1px;\n    content: \'\';\n    display: block;\n    height: 2px;\n    position: absolute;\n    top: 16px;\n    right: 8px;\n    transform: rotate(-45deg);\n    width: 16px;\n  }\n\n  &::after {\n    background: #808d96;\n    border-radius: 1px;\n    content: \'\';\n    display: block;\n    height: 2px;\n    position: absolute;\n    top: 16px;\n    right: 8px;\n    transform: rotate(45deg);\n    width: 16px;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  border-radius: 4px;\n  overflow: hidden;\n'], ['\n  border-radius: 4px;\n  overflow: hidden;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  font-size: 12px;\n  line-height: 1.5;\n'], ['\n  font-size: 12px;\n  line-height: 1.5;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  text-decoration: none;\n\n  &:hover {\n    opacity: 0.8;\n    text-decoration: none;\n  }\n  &:link, &:visited {\n    text-decoration: none;\n  }\n'], ['\n  display: flex;\n  flex-direction: column;\n  text-decoration: none;\n\n  &:hover {\n    opacity: 0.8;\n    text-decoration: none;\n  }\n  &:link, &:visited {\n    text-decoration: none;\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  height: 157px;\n  width: 300px;\n'], ['\n  height: 157px;\n  width: 300px;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  padding: 8px 12px 12px;\n'], ['\n  padding: 8px 12px 12px;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: #24243f;\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0 0 4px;\n'], ['\n  color: #24243f;\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0 0 4px;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  color: #808d96;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n'], ['\n  color: #808d96;\n  margin: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n  color: #0b41a0;\n  font-size: 14px;\n  font-weight: bold;\n  margin: 0 0 8px;\n'], ['\n  color: #0b41a0;\n  font-size: 14px;\n  font-weight: bold;\n  margin: 0 0 8px;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n  background-color: #0b41a0;\n  border-radius: 4px;\n  color: #fff;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 1;\n  margin-right: 8px;\n  padding: 5px 6px;\n'], ['\n  background-color: #0b41a0;\n  border-radius: 4px;\n  color: #fff;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 1;\n  margin-right: 8px;\n  padding: 5px 6px;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _KoruliTargetBannerUtilities = require('../../_KoruliTargetBannerUtilities');

/*---- CSS定義 ----*/

var bannerStyles = (0, _emotionCss.css)(_templateObject, _KoruliTargetBannerUtilities.BANNER_CLOSED_CLASS);

var bannerCloseIconStyles = (0, _emotionCss.css)(_templateObject2);

var bannerListStyles = (0, _emotionCss.css)(_templateObject3);

var bannerItemStyles = (0, _emotionCss.css)(_templateObject4);

var bannerLinkStyles = (0, _emotionCss.css)(_templateObject5);

var bannerImageStyles = (0, _emotionCss.css)(_templateObject6);

var bannerInfoStyles = (0, _emotionCss.css)(_templateObject7);

var bannerTitleStyles = (0, _emotionCss.css)(_templateObject8);

var bannerOtherInfoStyles = (0, _emotionCss.css)(_templateObject9);

var bannerRecommendBlockStyles = (0, _emotionCss.css)(_templateObject10);

var recommendIconStyles = (0, _emotionCss.css)(_templateObject11);

/*---- バナーフォーマット定義 ----*/

/**
 * @description 吸着バナーDOMの生成
 * @param {object} data - バナー設定情報
 * @param {object} targetBannerList - バナー情報
 * @param {number} index - バナー枠内の最初の掲載個所No.
 * @returns {string} - 吸着バナー枠のHTML DOM文字列
 */
var fixedBannerHtml = function fixedBannerHtml(data, targetBannerList, index) {
  if (targetBannerList.length === 0) return;

  var bannerData = targetBannerList[0];
  var bannerHtml = __bannerCassetteHtml(bannerData.creative1, bannerData.redirect_url, bannerData.ad_id, bannerData.data, index);

  return '\n    <div class="' + bannerStyles + ' js-fixedTargetBanner ' + _KoruliTargetBannerUtilities.BANNER_CLOSED_CLASS + '">\n      <div class="' + bannerListStyles + '">\n        ' + bannerHtml + '\n      </div>\n      <i\n        class="' + bannerCloseIconStyles + ' js-fixedTargetBannerClose"\n        data-banner-index="' + index + '"\n        data-banner-adid="' + bannerData.ad_id + '"\n      ></i>\n    </div>\n  ';
};

/**
 * @description 吸着バナーの単体HTMLフォーマット生成
 * @param {string} bannerImage - バナー画像URL
 * @param {string} linkUrl - 遷移先URL
 * @param {string} adId - バナーの広告ID
 * @param {object} bannerData - バナー情報
 * @param {number} index - バナーの掲載個所No.
 * @returns {string} - 吸着バナーの単体HTML DOM文字列
 */
var __bannerCassetteHtml = function __bannerCassetteHtml(bannerImage, linkUrl, adId, bannerData, index) {
  return '\n    <div class="' + bannerItemStyles + '">\n      <a\n        href="' + linkUrl + '"\n        class="' + bannerLinkStyles + ' ' + _KoruliTargetBannerUtilities.BANNER_LINK_HOOK_CLASS + '"\n        data-banner-index="' + index + '"\n        data-banner-adid="' + adId + '"\n        target="_blank"\n      >\n        <img class="' + bannerImageStyles + '" src="' + bannerImage + '" alt="' + bannerData.title + '">\n        <div class="' + bannerInfoStyles + '">\n          <div class="' + bannerRecommendBlockStyles + '">\n            <span class="' + recommendIconStyles + '">PickUp</span>おすすめの学校情報\n          </div>\n          <div class="' + bannerTitleStyles + '">' + bannerData.title + '</div>\n          <div class="' + bannerOtherInfoStyles + '">' + bannerData.category + '／' + bannerData.area + '</div>\n        </div>\n      </a>\n    </div>\n  ';
};

exports.fixedBannerHtml = fixedBannerHtml;

},{"../../_KoruliTargetBannerUtilities":18,"@emotion/css":5}],26:[function(require,module,exports){
/**
 * [23卒バナー商品] タイトルコンポーネント
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  max-width: 680px;\n  margin: 0 auto;\n'], ['\n  max-width: 680px;\n  margin: 0 auto;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  text-align: center;\n'], ['\n  text-align: center;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  text-align: left;\n'], ['\n  text-align: left;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 1.5;\n  margin-bottom: 16px;\n'], ['\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 1.5;\n  margin-bottom: 16px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 1.5;\n  margin: 0 auto;\n  width: 152px;\n'], ['\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 1.5;\n  margin: 0 auto;\n  width: 152px;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  background-color: #3ec1bd;\n  border-radius: 4px;\n  color: #fff;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 1;\n  margin: 0 8px 0 0;\n  padding: 5px 6px;\n  vertical-align: 2px;\n\n  &.is-rightColumn {\n    margin: 0 0 4px;\n  }\n'], ['\n  background-color: #3ec1bd;\n  border-radius: 4px;\n  color: #fff;\n  display: inline-block;\n  font-size: 12px;\n  font-weight: bold;\n  line-height: 1;\n  margin: 0 8px 0 0;\n  padding: 5px 6px;\n  vertical-align: 2px;\n\n  &.is-rightColumn {\n    margin: 0 0 4px;\n  }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  ', '\n  font-weight: 500;\n'], ['\n  ', '\n  font-weight: 500;\n']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var _emotionCss = require('@emotion/css');

var _KoruliTargetBannerUtilities = require('../../_KoruliTargetBannerUtilities');

/*---- CSS定義 ----*/
var titleBoxStyles = (0, _emotionCss.css)(_templateObject);

var titleCenterStyles = (0, _emotionCss.css)(_templateObject2);

var titleLeftStyles = (0, _emotionCss.css)(_templateObject3);

var titleRightColumnStyles = (0, _emotionCss.css)(_templateObject3);

var textStyles = (0, _emotionCss.css)(_templateObject4);

var textRightColumnStyles = (0, _emotionCss.css)(_templateObject5);

var iconStyles = (0, _emotionCss.css)(_templateObject6);

var jornalTextStyles = (0, _emotionCss.css)(_templateObject7, textRightColumnStyles);

var jornalIconStyles = (0, _emotionCss.css)(_templateObject7, iconStyles);

var titleText = 'おすすめの学校情報';

var getAlignTypeStyle = function getAlignTypeStyle(alignType) {
  return alignType === _KoruliTargetBannerUtilities.ALIGN_TYPES.CENTER ? titleCenterStyles : titleLeftStyles;
};

/*---- タイトルフォーマット定義 ----*/

var titleHtml = function titleHtml(alignType) {
  var titleStyle = getAlignTypeStyle(alignType);
  return '\n    <div class="' + titleBoxStyles + ' ' + titleStyle + '">\n      <div class="' + textStyles + '">\n        <span class="' + iconStyles + '">PickUp</span>' + titleText + '\n      </div>\n    </div>\n  ';
};

var fontSmallRightColumnHtml = function fontSmallRightColumnHtml(alignType) {
  var titleStyle = getAlignTypeStyle(alignType);
  return '\n    <div class="' + titleRightColumnStyles + ' ' + titleStyle + '">\n      <div class="' + textRightColumnStyles + '">\n        <span class="' + iconStyles + ' is-rightColumn">PickUp</span><br>\n        ' + titleText + '\n      </div>\n    </div>\n  ';
};

// 高校生なう用
var journalHtml = function journalHtml() {
  return '\n    <div class="' + titleRightColumnStyles + ' ' + titleLeftStyles + '">\n      <div class="' + jornalTextStyles + '">\n        <span class="' + jornalIconStyles + ' is-rightColumn">PickUp</span><br>\n        おすすめの<br>大学・専門学校情報\n      </div>\n    </div>\n  ';
};

/**
 * @description タイトルDOMの設定
 * @param {string} titleType - タイトル種別
 * @param {string} alignType - align設定
 * @returns {string} - タイトルのHTML DOM文字列
 */
var createBannerTitleHtml = function createBannerTitleHtml(titleType, alignType) {
  // 呼び出し元から渡されたバナー表示タイプに基づいたバナーHTMLを出力
  switch (titleType) {
    case _KoruliTargetBannerUtilities.TITLE_TYPES.NORMAL:
    case _KoruliTargetBannerUtilities.TITLE_TYPES.FONT_LARGE:
    case _KoruliTargetBannerUtilities.TITLE_TYPES.FONT_SMALL:
      return titleHtml(alignType);

    case _KoruliTargetBannerUtilities.TITLE_TYPES.FONT_SMALL_RIGHT_COLUMN:
      return fontSmallRightColumnHtml(alignType);

    case _KoruliTargetBannerUtilities.TITLE_TYPES.JOURNAL:
      return journalHtml();

    default:
      return '';
  }
};

exports.createBannerTitleHtml = createBannerTitleHtml;

},{"../../_KoruliTargetBannerUtilities":18,"@emotion/css":5}],27:[function(require,module,exports){
// PageUtil
// 特定のページ判定やページの情報を切り出すツールをまとめたコンポーネント

/**
 * @description 学校配下ページの判定。いずれかのディレクトリ名と「SC(大文字)」の前方一致チェック
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var isGakkoPage = function isGakkoPage() {
  var paths = location.pathname.split('/');
  var pattern = /^SC.*$/;
  return paths.some(function (path) {
    return pattern.test(path);
  });
};

/**
 * @description pathnameの中から「SC」前方一致＆8桁の文字列を学校コードとして返す
 *              ※IE11に対応するためにArray.find()を使わない
 */
var getGakkoCd = function getGakkoCd() {
  var paths = location.pathname.split('/');
  var pattern = /^SC.*$/;
  var gakkoCd = "";
  for (var i = 0; i < paths.length; ++i) {
    if (pattern.test(paths[i])) {
      gakkoCd = paths[i];
      break;
    }
  }
  return gakkoCd;
};

/**
 * @description MFI対象ぺージかどうか判別する。
 *              ※SPビューの際でもp_common.jsが使用されるページ群
 * @return {Boolean} - MFI対象ぺージの場合true
 */
var isUsedForSpPage = function isUsedForSpPage() {
  var listUsedForSpPage = ['Gkyouju', 'GClub', 'Gfestival', 'Gcafeteria', 'Glibrary', 'Ggakuchou', 'Gdaigakuin'];
  return listUsedForSpPage.indexOf(window.trace_p) !== -1;
};

/**
 * @description 端末がスマートフォンかどうかを判別する。
 *              ※サーバーサイドのua判定と合わせている(MobileService.isSmartphone())
 * @return {Boolean} - Spの場合true
 */
var isSp = function isSp() {
  var ua = navigator.userAgent;
  var isMatchDevice = 0 <= ua.indexOf('iPhone') || 0 <= ua.indexOf('Android') || 0 <= ua.indexOf('iPod') || 0 <= ua.indexOf('Firefox');
  return isMatchDevice && ua.indexOf('Mobile');
};

/**
 * @description 本番環境かどうかを判別する。
 *              ※サーバーサイドでの判別を原則とし、やむをえない場合にのみこの関数を利用してください
 * @return {Boolean} - 本番の場合true
 */
var isProduction = function isProduction() {
  return location.hostname === 'shingakunet.com';
};

exports['default'] = { isGakkoPage: isGakkoPage, getGakkoCd: getGakkoCd, isUsedForSpPage: isUsedForSpPage, isSp: isSp, isProduction: isProduction };
module.exports = exports['default'];

},{}],28:[function(require,module,exports){
/**
 * [23RM-03] バナー施策 rrnet汎用PC
 * 「reset_html/design_html/webapp_src/js/assets」配下のモジュールに依存しています。
 */
'use strict';

var _jsAssetsComponentPc_p_createKoruliBannerPc = require('../../../../js/assets/component/pc/_p_createKoruliBannerPc');

var _jsAssetsComponent_KoruliTargetBannerUtilities = require('../../../../js/assets/component/_KoruliTargetBannerUtilities');

var _component_PageUtil = require('../component/_PageUtil');

// Koruliバナー用グローバル変数
window.frontend = window.frontend || {};
frontend.koruliFrameId = _jsAssetsComponent_KoruliTargetBannerUtilities.BANNER_COMMON_CODE; // リタゲ枠の共通ID
frontend.isKoruliHostProduction = (0, _component_PageUtil.isProduction)(); // rnet配下はjsで開発/本番を判定する

// HTMLのバナー表示用要素で設定しているバナー表示優先度をキーに、バナーの表示仕様を設定
var bannerSettings = [{
  priority: 1, // バナーの表示優先度。バナー設置用HTMLタグに設定している「data-banner-priority」の値と連動
  bannerNum: 1, // 対象枠のバナー表示数
  bannerType: _jsAssetsComponent_KoruliTargetBannerUtilities.BANNER_TYPES.CASSETTE_MAIN,
  titleType: _jsAssetsComponent_KoruliTargetBannerUtilities.TITLE_TYPES.NORMAL,
  alignType: _jsAssetsComponent_KoruliTargetBannerUtilities.ALIGN_TYPES.CENTER,
  backgroundType: _jsAssetsComponent_KoruliTargetBannerUtilities.BACKGROUND_TYPES.LIGHT_BLUE,
  outerMarginStyle: 'margin: 0px auto 20px;'
}, {
  priority: 2,
  bannerNum: 1,
  bannerType: _jsAssetsComponent_KoruliTargetBannerUtilities.BANNER_TYPES.FIXED
}];

// 上記bannerSettingsのbannerNumを合算し、必要なバナーの総数を取得する
var totalBannerNum = 0;
bannerSettings.forEach(function (data) {
  return totalBannerNum += data.bannerNum;
});

new _jsAssetsComponentPc_p_createKoruliBannerPc.KoruliTargetBannerPc({
  bannerSelector: '.js-targetBannerView', // バナー設置用HTMLタグ要素。同じ画面に複数箇所設置する場合、全て同じclass名を設定する。（data-banner-priorityの値でそれぞれのバナーを識別する）
  bannerNum: totalBannerNum, // 必要なバナー数
  bannerSettings: bannerSettings
});

},{"../../../../js/assets/component/_KoruliTargetBannerUtilities":18,"../../../../js/assets/component/pc/_p_createKoruliBannerPc":21,"../component/_PageUtil":27}]},{},[28]);
